var items = {
  "block.minecraft.acacia_button": "Копче од акација",
  "block.minecraft.acacia_door": "Врата од акација",
  "block.minecraft.acacia_fence": "Ограда од акација",
  "block.minecraft.acacia_fence_gate": "Врата за ограда од акација",
  "block.minecraft.acacia_hanging_sign": "Багремов висечки знак",
  "block.minecraft.acacia_leaves": "Лисја од акација",
  "block.minecraft.acacia_log": "Труп од акација",
  "block.minecraft.acacia_planks": "Даски од акација",
  "block.minecraft.acacia_pressure_plate": "Притисна плоча од акација",
  "block.minecraft.acacia_sapling": "Фиданка од акација",
  "block.minecraft.acacia_shelf": "Acacia Shelf",
  "block.minecraft.acacia_sign": "Знак од акација",
  "block.minecraft.acacia_slab": "Плоча од акација",
  "block.minecraft.acacia_stairs": "Скали од акација",
  "block.minecraft.acacia_trapdoor": "Врата-стапица од акација",
  "block.minecraft.acacia_wall_hanging_sign": "Висечки знак од багрем",
  "block.minecraft.acacia_wall_sign": "Ѕиден знак од акација",
  "block.minecraft.acacia_wood": "Акација",
  "block.minecraft.activator_rail": "Активаторска пруга",
  "block.minecraft.air": "Воздyx",
  "block.minecraft.allium": "Алиум",
  "block.minecraft.amethyst_block": "Блок на аметист",
  "block.minecraft.amethyst_cluster": "Аметист кластер",
  "block.minecraft.ancient_debris": "Древни Остаци",
  "block.minecraft.andesite": "Андезит",
  "block.minecraft.andesite_slab": "Андезитна плоча",
  "block.minecraft.andesite_stairs": "Андезитни скали",
  "block.minecraft.andesite_wall": "Андезитен ѕид",
  "block.minecraft.anvil": "Наковална",
  "block.minecraft.attached_melon_stem": "Поврзано стебло од лубеница",
  "block.minecraft.attached_pumpkin_stem": "Поврзано стебло од тиква",
  "block.minecraft.azalea": "Азалеа",
  "block.minecraft.azalea_leaves": "Азалеа Лисја",
  "block.minecraft.azure_bluet": "Лазурен блует",
  "block.minecraft.bamboo": "Бамбус",
  "block.minecraft.bamboo_block": "Блок од бамбус",
  "block.minecraft.bamboo_button": "Бамбусово копче",
  "block.minecraft.bamboo_door": "Бамбусова врата",
  "block.minecraft.bamboo_fence": "Бамбусова ограда",
  "block.minecraft.bamboo_fence_gate": "Бамбусова Порта",
  "block.minecraft.bamboo_hanging_sign": "Бамбусов висечки знак",
  "block.minecraft.bamboo_mosaic": "Бамбусов мозаик",
  "block.minecraft.bamboo_mosaic_slab": "Плоча од бамбусов мозаик",
  "block.minecraft.bamboo_mosaic_stairs": "Бамбусови мозаик скали",
  "block.minecraft.bamboo_planks": "Бамбусови штици",
  "block.minecraft.bamboo_pressure_plate": "Бамбусова плочка за притисок",
  "block.minecraft.bamboo_sapling": "Млад Бамбус",
  "block.minecraft.bamboo_shelf": "Bamboo Shelf",
  "block.minecraft.bamboo_sign": "Бамбусов знак",
  "block.minecraft.bamboo_slab": "Бамбусова плоча",
  "block.minecraft.bamboo_stairs": "Бамбусови скали",
  "block.minecraft.bamboo_trapdoor": "Бамбусова стапица",
  "block.minecraft.bamboo_wall_hanging_sign": "Бамбусов висечки знак",
  "block.minecraft.bamboo_wall_sign": "Бамбусов зиден знак",
  "block.minecraft.banner.base.black": "Целосно црно поле",
  "block.minecraft.banner.base.blue": "Fully Blue Field",
  "block.minecraft.banner.base.brown": "Целосно кафеаво поле",
  "block.minecraft.banner.base.cyan": "Целосно цијано поле",
  "block.minecraft.banner.base.gray": "Целосно сиво поле",
  "block.minecraft.banner.base.green": "Целосно зелено поле",
  "block.minecraft.banner.base.light_blue": "Целосно светло сино поле",
  "block.minecraft.banner.base.light_gray": "Целосно светло сиво поле",
  "block.minecraft.banner.base.lime": "Целосно варово поле",
  "block.minecraft.banner.base.magenta": "Целосно поле со магента",
  "block.minecraft.banner.base.orange": "Целосно портокалово поле",
  "block.minecraft.banner.base.pink": "Целосно розово поле",
  "block.minecraft.banner.base.purple": "Целосно пурпурно поле",
  "block.minecraft.banner.base.red": "Целосно црвено поле",
  "block.minecraft.banner.base.white": "Целосно бело поле",
  "block.minecraft.banner.base.yellow": "Целосно жолто поле",
  "block.minecraft.banner.border.black": "Црна рамка",
  "block.minecraft.banner.border.blue": "Сина рамка",
  "block.minecraft.banner.border.brown": "Кафеава рамка",
  "block.minecraft.banner.border.cyan": "Сино-зелена рамка",
  "block.minecraft.banner.border.gray": "Сива рамка",
  "block.minecraft.banner.border.green": "Зелена рамка",
  "block.minecraft.banner.border.light_blue": "Светлосина рамка",
  "block.minecraft.banner.border.light_gray": "Светлосива рамка",
  "block.minecraft.banner.border.lime": "Жолто-зелена рамка",
  "block.minecraft.banner.border.magenta": "Магента рамка",
  "block.minecraft.banner.border.orange": "Портокалова рамка",
  "block.minecraft.banner.border.pink": "Розова рамка",
  "block.minecraft.banner.border.purple": "Виолетова рамка",
  "block.minecraft.banner.border.red": "Црвена рамка",
  "block.minecraft.banner.border.white": "Бела рамка",
  "block.minecraft.banner.border.yellow": "Жолта рамка",
  "block.minecraft.banner.bricks.black": "Црно ѕидано поле",
  "block.minecraft.banner.bricks.blue": "Сино ѕидано поле",
  "block.minecraft.banner.bricks.brown": "Кафеаво ѕидано поле",
  "block.minecraft.banner.bricks.cyan": "Сино-зелено ѕидано поле",
  "block.minecraft.banner.bricks.gray": "Сиво ѕидано поле",
  "block.minecraft.banner.bricks.green": "Зелено ѕидано поле",
  "block.minecraft.banner.bricks.light_blue": "Светлосино ѕидано поле",
  "block.minecraft.banner.bricks.light_gray": "Светлосиво ѕидано поле",
  "block.minecraft.banner.bricks.lime": "Жолто-зелено ѕидано поле",
  "block.minecraft.banner.bricks.magenta": "Магента ѕидано поле",
  "block.minecraft.banner.bricks.orange": "Портокалово ѕидано поле",
  "block.minecraft.banner.bricks.pink": "Розово ѕидано поле",
  "block.minecraft.banner.bricks.purple": "Виолетово ѕидано поле",
  "block.minecraft.banner.bricks.red": "Црвено ѕидано поле",
  "block.minecraft.banner.bricks.white": "Бело ѕидано поле",
  "block.minecraft.banner.bricks.yellow": "Жолто ѕидано поле",
  "block.minecraft.banner.circle.black": "Црн круг",
  "block.minecraft.banner.circle.blue": "Син круг",
  "block.minecraft.banner.circle.brown": "Кафеав круг",
  "block.minecraft.banner.circle.cyan": "Сино-зелен круг",
  "block.minecraft.banner.circle.gray": "Сив круг",
  "block.minecraft.banner.circle.green": "Зелен круг",
  "block.minecraft.banner.circle.light_blue": "Светлосин круг",
  "block.minecraft.banner.circle.light_gray": "Светлосив круг",
  "block.minecraft.banner.circle.lime": "Жолто-зелен круг",
  "block.minecraft.banner.circle.magenta": "Магента круг",
  "block.minecraft.banner.circle.orange": "Портокалов круг",
  "block.minecraft.banner.circle.pink": "Розов круг",
  "block.minecraft.banner.circle.purple": "Виолетов круг",
  "block.minecraft.banner.circle.red": "Црвен круг",
  "block.minecraft.banner.circle.white": "Бел круг",
  "block.minecraft.banner.circle.yellow": "Жолт круг",
  "block.minecraft.banner.creeper.black": "Црна фигура на крипер",
  "block.minecraft.banner.creeper.blue": "Сина фигура на крипер",
  "block.minecraft.banner.creeper.brown": "Кафеава фигура на крипер",
  "block.minecraft.banner.creeper.cyan": "Сино-зелена фигура на крипер",
  "block.minecraft.banner.creeper.gray": "Сива фигура на крипер",
  "block.minecraft.banner.creeper.green": "Зелена фигура на крипер",
  "block.minecraft.banner.creeper.light_blue": "Светлосина фигура на крипер",
  "block.minecraft.banner.creeper.light_gray": "Светлосива фигура на крипер",
  "block.minecraft.banner.creeper.lime": "Жолто-зелена фигура на крипер",
  "block.minecraft.banner.creeper.magenta": "Магента фигура на крипер",
  "block.minecraft.banner.creeper.orange": "Портокалова фигура на крипер",
  "block.minecraft.banner.creeper.pink": "Розова фигура на крипер",
  "block.minecraft.banner.creeper.purple": "Виолетова фигура на крипер",
  "block.minecraft.banner.creeper.red": "Црвена фигура на крипер",
  "block.minecraft.banner.creeper.white": "Бела фигура на крипер",
  "block.minecraft.banner.creeper.yellow": "Жолта фигура на крипер",
  "block.minecraft.banner.cross.black": "Црн Андреев крст",
  "block.minecraft.banner.cross.blue": "Син Андреев крст",
  "block.minecraft.banner.cross.brown": "Кафеав Андреев крст",
  "block.minecraft.banner.cross.cyan": "Сино-зелен Андреев крст",
  "block.minecraft.banner.cross.gray": "Сив Андреев крст",
  "block.minecraft.banner.cross.green": "Зелен Андреев крст",
  "block.minecraft.banner.cross.light_blue": "Светлосин Андреев крст",
  "block.minecraft.banner.cross.light_gray": "Светлосив Андреев крст",
  "block.minecraft.banner.cross.lime": "Жолто-зелен Андреев крст",
  "block.minecraft.banner.cross.magenta": "Магента Андреев крст",
  "block.minecraft.banner.cross.orange": "Портокалов Андреев крст",
  "block.minecraft.banner.cross.pink": "Розов Андреев крст",
  "block.minecraft.banner.cross.purple": "Виолетов Андреев крст",
  "block.minecraft.banner.cross.red": "Црвен Андреев крст",
  "block.minecraft.banner.cross.white": "Бел Андреев крст",
  "block.minecraft.banner.cross.yellow": "Жолт Андреев крст",
  "block.minecraft.banner.curly_border.black": "Црна запчеста рамка",
  "block.minecraft.banner.curly_border.blue": "Сина запчеста рамка",
  "block.minecraft.banner.curly_border.brown": "Кафеава запчеста рамка",
  "block.minecraft.banner.curly_border.cyan": "Сино-зелена запчеста рамка",
  "block.minecraft.banner.curly_border.gray": "Сива запчеста рамка",
  "block.minecraft.banner.curly_border.green": "Зелена запчеста рамка",
  "block.minecraft.banner.curly_border.light_blue": "Светлосина запчеста рамка",
  "block.minecraft.banner.curly_border.light_gray": "Светлосива запчеста рамка",
  "block.minecraft.banner.curly_border.lime": "Жолто-зелена запчеста рамка",
  "block.minecraft.banner.curly_border.magenta": "Магента запчеста рамка",
  "block.minecraft.banner.curly_border.orange": "Портокалова запчеста рамка",
  "block.minecraft.banner.curly_border.pink": "Розова запчеста рамка",
  "block.minecraft.banner.curly_border.purple": "Виолетова запчеста рамка",
  "block.minecraft.banner.curly_border.red": "Црвена запчеста рамка",
  "block.minecraft.banner.curly_border.white": "Бела запчеста рамка",
  "block.minecraft.banner.curly_border.yellow": "Жолта запчеста рамка",
  "block.minecraft.banner.diagonal_left.black": "Црна горна лева половина",
  "block.minecraft.banner.diagonal_left.blue": "Сина горна лева половина",
  "block.minecraft.banner.diagonal_left.brown": "Кафеава горна лева половина",
  "block.minecraft.banner.diagonal_left.cyan": "Сино-зелена горна лева половина",
  "block.minecraft.banner.diagonal_left.gray": "Сива горна лева половина",
  "block.minecraft.banner.diagonal_left.green": "Зелена горна лева половина",
  "block.minecraft.banner.diagonal_left.light_blue": "Светлосина горна лева половина",
  "block.minecraft.banner.diagonal_left.light_gray": "Светлосива горна лева половина",
  "block.minecraft.banner.diagonal_left.lime": "Жолто-зелена горна лева половина",
  "block.minecraft.banner.diagonal_left.magenta": "Магента горна лева половина",
  "block.minecraft.banner.diagonal_left.orange": "Портокалова горна лева половина",
  "block.minecraft.banner.diagonal_left.pink": "Розова горна лева половина",
  "block.minecraft.banner.diagonal_left.purple": "Виолетова горна лева половина",
  "block.minecraft.banner.diagonal_left.red": "Црвена горна лева половина",
  "block.minecraft.banner.diagonal_left.white": "Бела горна лева половина",
  "block.minecraft.banner.diagonal_left.yellow": "Жолта горна лева половина",
  "block.minecraft.banner.diagonal_right.black": "Црна горна десна половина",
  "block.minecraft.banner.diagonal_right.blue": "Сина горна десна половина",
  "block.minecraft.banner.diagonal_right.brown": "Кафеава горна десна половина",
  "block.minecraft.banner.diagonal_right.cyan": "Сино-зелена горна десна половина",
  "block.minecraft.banner.diagonal_right.gray": "Сива горна десна половина",
  "block.minecraft.banner.diagonal_right.green": "Зелена горна десна половина",
  "block.minecraft.banner.diagonal_right.light_blue": "Светлосина горна десна половина",
  "block.minecraft.banner.diagonal_right.light_gray": "Светлосива горна десна половина",
  "block.minecraft.banner.diagonal_right.lime": "Жолто-зелена горна десна половина",
  "block.minecraft.banner.diagonal_right.magenta": "Магента горна десна половина",
  "block.minecraft.banner.diagonal_right.orange": "Портокалова горна десна половина",
  "block.minecraft.banner.diagonal_right.pink": "Розова горна десна половина",
  "block.minecraft.banner.diagonal_right.purple": "Виолетова горна десна половина",
  "block.minecraft.banner.diagonal_right.red": "Црвена горна десна половина",
  "block.minecraft.banner.diagonal_right.white": "Бела горна десна половина",
  "block.minecraft.banner.diagonal_right.yellow": "Жолта горна десна половина",
  "block.minecraft.banner.diagonal_up_left.black": "Црна долна лева половина",
  "block.minecraft.banner.diagonal_up_left.blue": "Сина долна лева половина",
  "block.minecraft.banner.diagonal_up_left.brown": "Кафеава долна лева половина",
  "block.minecraft.banner.diagonal_up_left.cyan": "Сино-зелена долна лева половина",
  "block.minecraft.banner.diagonal_up_left.gray": "Сива долна лева половина",
  "block.minecraft.banner.diagonal_up_left.green": "Зелена долна лева половина",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Светлосина долна лева половина",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Светлосива долна лева половина",
  "block.minecraft.banner.diagonal_up_left.lime": "Жолто-зелена долна лева половина",
  "block.minecraft.banner.diagonal_up_left.magenta": "Магента долна лева половина",
  "block.minecraft.banner.diagonal_up_left.orange": "Портокалова долна лева половина",
  "block.minecraft.banner.diagonal_up_left.pink": "Розова долна лева половина",
  "block.minecraft.banner.diagonal_up_left.purple": "Виолетова долна лева половина",
  "block.minecraft.banner.diagonal_up_left.red": "Црвена долна лева половина",
  "block.minecraft.banner.diagonal_up_left.white": "Бела долна лева половина",
  "block.minecraft.banner.diagonal_up_left.yellow": "Жолта долна лева половина",
  "block.minecraft.banner.diagonal_up_right.black": "Црна долна десна половина",
  "block.minecraft.banner.diagonal_up_right.blue": "Сина долна десна половина",
  "block.minecraft.banner.diagonal_up_right.brown": "Кафеава долна десна половина",
  "block.minecraft.banner.diagonal_up_right.cyan": "Сино-зелена долна десна половина",
  "block.minecraft.banner.diagonal_up_right.gray": "Сива долна десна половина",
  "block.minecraft.banner.diagonal_up_right.green": "Зелена долна десна половина",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Светлосина долна десна половина",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Светлосива долна десна половина",
  "block.minecraft.banner.diagonal_up_right.lime": "Жолто-зелена долна десна половина",
  "block.minecraft.banner.diagonal_up_right.magenta": "Магента долна десна половина",
  "block.minecraft.banner.diagonal_up_right.orange": "Портокалова долна десна половина",
  "block.minecraft.banner.diagonal_up_right.pink": "Розова долна десна половина",
  "block.minecraft.banner.diagonal_up_right.purple": "Виолетова долна десна половина",
  "block.minecraft.banner.diagonal_up_right.red": "Црвена долна десна половина",
  "block.minecraft.banner.diagonal_up_right.white": "Бела долна десна половина",
  "block.minecraft.banner.diagonal_up_right.yellow": "Жолта долна десна половина",
  "block.minecraft.banner.flow.black": "Black Flow",
  "block.minecraft.banner.flow.blue": "Blue Flow",
  "block.minecraft.banner.flow.brown": "Brown Flow",
  "block.minecraft.banner.flow.cyan": "Cyan Flow",
  "block.minecraft.banner.flow.gray": "Gray Flow",
  "block.minecraft.banner.flow.green": "Green Flow",
  "block.minecraft.banner.flow.light_blue": "Light Blue Flow",
  "block.minecraft.banner.flow.light_gray": "Light Gray Flow",
  "block.minecraft.banner.flow.lime": "Lime Flow",
  "block.minecraft.banner.flow.magenta": "Magenta Flow",
  "block.minecraft.banner.flow.orange": "Orange Flow",
  "block.minecraft.banner.flow.pink": "Pink Flow",
  "block.minecraft.banner.flow.purple": "Purple Flow",
  "block.minecraft.banner.flow.red": "Red Flow",
  "block.minecraft.banner.flow.white": "White Flow",
  "block.minecraft.banner.flow.yellow": "Yellow Flow",
  "block.minecraft.banner.flower.black": "Црна фигура на цвет",
  "block.minecraft.banner.flower.blue": "Сина фигура на цвет",
  "block.minecraft.banner.flower.brown": "Кафеава фигура на цвет",
  "block.minecraft.banner.flower.cyan": "Сино-зелена фигура на цвет",
  "block.minecraft.banner.flower.gray": "Сива фигура на цвет",
  "block.minecraft.banner.flower.green": "Зелена фигура на цвет",
  "block.minecraft.banner.flower.light_blue": "Светлосина фигура на цвет",
  "block.minecraft.banner.flower.light_gray": "Светлосива фигура на цвет",
  "block.minecraft.banner.flower.lime": "Жолто-зелена фигура на цвет",
  "block.minecraft.banner.flower.magenta": "Магента фигура на цвет",
  "block.minecraft.banner.flower.orange": "Портокалова фигура на цвет",
  "block.minecraft.banner.flower.pink": "Розова фигура на цвет",
  "block.minecraft.banner.flower.purple": "Виолетова фигура на цвет",
  "block.minecraft.banner.flower.red": "Црвена фигура на цвет",
  "block.minecraft.banner.flower.white": "Бела фигура на цвет",
  "block.minecraft.banner.flower.yellow": "Жолта фигура на цвет",
  "block.minecraft.banner.globe.black": "Црн глобус",
  "block.minecraft.banner.globe.blue": "Син глобус",
  "block.minecraft.banner.globe.brown": "Кафеав глобус",
  "block.minecraft.banner.globe.cyan": "Сино-зелен глобус",
  "block.minecraft.banner.globe.gray": "Сив глобус",
  "block.minecraft.banner.globe.green": "Зелен глобус",
  "block.minecraft.banner.globe.light_blue": "Светлосин глобус",
  "block.minecraft.banner.globe.light_gray": "Светлосив глобус",
  "block.minecraft.banner.globe.lime": "Жолто-зелен глобус",
  "block.minecraft.banner.globe.magenta": "Магента глобус",
  "block.minecraft.banner.globe.orange": "Портокалов глобус",
  "block.minecraft.banner.globe.pink": "Розов глобус",
  "block.minecraft.banner.globe.purple": "Виолетов глобус",
  "block.minecraft.banner.globe.red": "Црвен глобус",
  "block.minecraft.banner.globe.white": "Бел глобус",
  "block.minecraft.banner.globe.yellow": "Жолт глобус",
  "block.minecraft.banner.gradient.black": "Црн горен градиент",
  "block.minecraft.banner.gradient.blue": "Син горен градиент",
  "block.minecraft.banner.gradient.brown": "Кафеав горен градиент",
  "block.minecraft.banner.gradient.cyan": "Сино-зелен горен градиент",
  "block.minecraft.banner.gradient.gray": "Сив горен градиент",
  "block.minecraft.banner.gradient.green": "Зелен горен градиент",
  "block.minecraft.banner.gradient.light_blue": "Светлосин горен градиент",
  "block.minecraft.banner.gradient.light_gray": "Светлосив горен градиент",
  "block.minecraft.banner.gradient.lime": "Жолто-зелен горен градиент",
  "block.minecraft.banner.gradient.magenta": "Магента горен градиент",
  "block.minecraft.banner.gradient.orange": "Портокалов горен градиент",
  "block.minecraft.banner.gradient.pink": "Розов горен градиент",
  "block.minecraft.banner.gradient.purple": "Виолетов горен градиент",
  "block.minecraft.banner.gradient.red": "Црвен горен градиент",
  "block.minecraft.banner.gradient.white": "Бел горен градиент",
  "block.minecraft.banner.gradient.yellow": "Жолт горен градиент",
  "block.minecraft.banner.gradient_up.black": "Црн долен градиент",
  "block.minecraft.banner.gradient_up.blue": "Син долен градиент",
  "block.minecraft.banner.gradient_up.brown": "Кафеав долен градиент",
  "block.minecraft.banner.gradient_up.cyan": "Сино-зелен долен градиент",
  "block.minecraft.banner.gradient_up.gray": "Сив долен градиент",
  "block.minecraft.banner.gradient_up.green": "Зелен долен градиент",
  "block.minecraft.banner.gradient_up.light_blue": "Светлосин долен градиент",
  "block.minecraft.banner.gradient_up.light_gray": "Светлосив долен градиент",
  "block.minecraft.banner.gradient_up.lime": "Жолто-зелен долен градиент",
  "block.minecraft.banner.gradient_up.magenta": "Магента долен градиент",
  "block.minecraft.banner.gradient_up.orange": "Портокалов долен градиент",
  "block.minecraft.banner.gradient_up.pink": "Розов долен градиент",
  "block.minecraft.banner.gradient_up.purple": "Виолетов долен градиент",
  "block.minecraft.banner.gradient_up.red": "Црвен долен градиент",
  "block.minecraft.banner.gradient_up.white": "Бел долен градиент",
  "block.minecraft.banner.gradient_up.yellow": "Жолт долен градиент",
  "block.minecraft.banner.guster.black": "Black Guster",
  "block.minecraft.banner.guster.blue": "Blue Guster",
  "block.minecraft.banner.guster.brown": "Brown Guster",
  "block.minecraft.banner.guster.cyan": "Cyan Guster",
  "block.minecraft.banner.guster.gray": "Gray Guster",
  "block.minecraft.banner.guster.green": "Green Guster",
  "block.minecraft.banner.guster.light_blue": "Light Blue Guster",
  "block.minecraft.banner.guster.light_gray": "Light Gray Guster",
  "block.minecraft.banner.guster.lime": "Lime Guster",
  "block.minecraft.banner.guster.magenta": "Magenta Guster",
  "block.minecraft.banner.guster.orange": "Orange Guster",
  "block.minecraft.banner.guster.pink": "Pink Guster",
  "block.minecraft.banner.guster.purple": "Purple Guster",
  "block.minecraft.banner.guster.red": "Red Guster",
  "block.minecraft.banner.guster.white": "White Guster",
  "block.minecraft.banner.guster.yellow": "Yellow Guster",
  "block.minecraft.banner.half_horizontal.black": "Црна горна половина",
  "block.minecraft.banner.half_horizontal.blue": "Сина горна половина",
  "block.minecraft.banner.half_horizontal.brown": "Кафеава горна половина",
  "block.minecraft.banner.half_horizontal.cyan": "Сино-зелена горна половина",
  "block.minecraft.banner.half_horizontal.gray": "Сива горна половина",
  "block.minecraft.banner.half_horizontal.green": "Зелена горна половина",
  "block.minecraft.banner.half_horizontal.light_blue": "Светлосина горна половина",
  "block.minecraft.banner.half_horizontal.light_gray": "Светлосива горна половина",
  "block.minecraft.banner.half_horizontal.lime": "Жолто-зелена горна половина",
  "block.minecraft.banner.half_horizontal.magenta": "Магента горна половина",
  "block.minecraft.banner.half_horizontal.orange": "Портокалова горна половина",
  "block.minecraft.banner.half_horizontal.pink": "Розова горна половина",
  "block.minecraft.banner.half_horizontal.purple": "Виолетова горна половина",
  "block.minecraft.banner.half_horizontal.red": "Црвена горна половина",
  "block.minecraft.banner.half_horizontal.white": "Бела горна половина",
  "block.minecraft.banner.half_horizontal.yellow": "Жолта горна половина",
  "block.minecraft.banner.half_horizontal_bottom.black": "Црна долна половина",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Сина долна половина",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Кафеава долна половина",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Сино-зелена долна половина",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Сива долна половина",
  "block.minecraft.banner.half_horizontal_bottom.green": "Зелена долна половина",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Светлосина долна половина",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Светлосива долна половина",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Жолто-зелена долна половина",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Магента долна половина",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Портокалова долна половина",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Розова долна половина",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Виолетова долна половина",
  "block.minecraft.banner.half_horizontal_bottom.red": "Црвена долна половина",
  "block.minecraft.banner.half_horizontal_bottom.white": "Бела долна половина",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Жолта долна половина",
  "block.minecraft.banner.half_vertical.black": "Црна лева половина",
  "block.minecraft.banner.half_vertical.blue": "Сина лева половина",
  "block.minecraft.banner.half_vertical.brown": "Кафеава лева половина",
  "block.minecraft.banner.half_vertical.cyan": "Сино-зелена лева половина",
  "block.minecraft.banner.half_vertical.gray": "Сива лева половина",
  "block.minecraft.banner.half_vertical.green": "Зелена лева половина",
  "block.minecraft.banner.half_vertical.light_blue": "Светлосина лева половина",
  "block.minecraft.banner.half_vertical.light_gray": "Светлосива лева половина",
  "block.minecraft.banner.half_vertical.lime": "Жолто-зелена лева половина",
  "block.minecraft.banner.half_vertical.magenta": "Магента лева половина",
  "block.minecraft.banner.half_vertical.orange": "Портокалова лева половина",
  "block.minecraft.banner.half_vertical.pink": "Розова лева половина",
  "block.minecraft.banner.half_vertical.purple": "Виолетова лева половина",
  "block.minecraft.banner.half_vertical.red": "Црвена лева половина",
  "block.minecraft.banner.half_vertical.white": "Бела лева половина",
  "block.minecraft.banner.half_vertical.yellow": "Жолта лева половина",
  "block.minecraft.banner.half_vertical_right.black": "Црна десна половина",
  "block.minecraft.banner.half_vertical_right.blue": "Сина десна половина",
  "block.minecraft.banner.half_vertical_right.brown": "Кафеава десна половина",
  "block.minecraft.banner.half_vertical_right.cyan": "Сино-зелена десна половина",
  "block.minecraft.banner.half_vertical_right.gray": "Сива десна половина",
  "block.minecraft.banner.half_vertical_right.green": "Зелена десна половина",
  "block.minecraft.banner.half_vertical_right.light_blue": "Светлосина десна половина",
  "block.minecraft.banner.half_vertical_right.light_gray": "Светлосива десна половина",
  "block.minecraft.banner.half_vertical_right.lime": "Жолто-зелена десна половина",
  "block.minecraft.banner.half_vertical_right.magenta": "Магента десна половина",
  "block.minecraft.banner.half_vertical_right.orange": "Портокалова десна половина",
  "block.minecraft.banner.half_vertical_right.pink": "Розова десна половина",
  "block.minecraft.banner.half_vertical_right.purple": "Виолетова десна половина",
  "block.minecraft.banner.half_vertical_right.red": "Црвена десна половина",
  "block.minecraft.banner.half_vertical_right.white": "Бела десна половина",
  "block.minecraft.banner.half_vertical_right.yellow": "Жолта десна половина",
  "block.minecraft.banner.mojang.black": "Црно лого",
  "block.minecraft.banner.mojang.blue": "Сино лого",
  "block.minecraft.banner.mojang.brown": "Кафеаво лого",
  "block.minecraft.banner.mojang.cyan": "Сино-зелено лого",
  "block.minecraft.banner.mojang.gray": "Сиво лого",
  "block.minecraft.banner.mojang.green": "Зелено лого",
  "block.minecraft.banner.mojang.light_blue": "Светлосино лого",
  "block.minecraft.banner.mojang.light_gray": "Светлосиво лого",
  "block.minecraft.banner.mojang.lime": "Жолто-зелено лого",
  "block.minecraft.banner.mojang.magenta": "Магента лого",
  "block.minecraft.banner.mojang.orange": "Портокалово лого",
  "block.minecraft.banner.mojang.pink": "Розово лого",
  "block.minecraft.banner.mojang.purple": "Виолетово лого",
  "block.minecraft.banner.mojang.red": "Црвено лого",
  "block.minecraft.banner.mojang.white": "Бело лого",
  "block.minecraft.banner.mojang.yellow": "Жолто лого",
  "block.minecraft.banner.piglin.black": "Црна Муцка",
  "block.minecraft.banner.piglin.blue": "Циња Муцка",
  "block.minecraft.banner.piglin.brown": "Кафјава Муцка",
  "block.minecraft.banner.piglin.cyan": "Сињо-Зелена Муцка",
  "block.minecraft.banner.piglin.gray": "Сива Муцка",
  "block.minecraft.banner.piglin.green": "Зелена Муцка",
  "block.minecraft.banner.piglin.light_blue": "Светло Сина Муцка",
  "block.minecraft.banner.piglin.light_gray": "Светло Сива Муцка",
  "block.minecraft.banner.piglin.lime": "Светло-Зелена Муцка",
  "block.minecraft.banner.piglin.magenta": "Магента Муцка",
  "block.minecraft.banner.piglin.orange": "Портокалова Муцка",
  "block.minecraft.banner.piglin.pink": "Розова Муцка",
  "block.minecraft.banner.piglin.purple": "Лила Муцка",
  "block.minecraft.banner.piglin.red": "Црвена Муцка",
  "block.minecraft.banner.piglin.white": "Бела Муцка",
  "block.minecraft.banner.piglin.yellow": "Жлта Муцка",
  "block.minecraft.banner.rhombus.black": "Црн ромб",
  "block.minecraft.banner.rhombus.blue": "Син ромб",
  "block.minecraft.banner.rhombus.brown": "Кафеав ромб",
  "block.minecraft.banner.rhombus.cyan": "Сино-зелен ромб",
  "block.minecraft.banner.rhombus.gray": "Сив ромб",
  "block.minecraft.banner.rhombus.green": "Зелен ромб",
  "block.minecraft.banner.rhombus.light_blue": "Светлосин ромб",
  "block.minecraft.banner.rhombus.light_gray": "Светлосив ромб",
  "block.minecraft.banner.rhombus.lime": "Жолто-зелен ромб",
  "block.minecraft.banner.rhombus.magenta": "Магента ромб",
  "block.minecraft.banner.rhombus.orange": "Портокалов ромб",
  "block.minecraft.banner.rhombus.pink": "Розов ромб",
  "block.minecraft.banner.rhombus.purple": "Виолетов ромб",
  "block.minecraft.banner.rhombus.red": "Црвен ромб",
  "block.minecraft.banner.rhombus.white": "Бел ромб",
  "block.minecraft.banner.rhombus.yellow": "Жолт ромб",
  "block.minecraft.banner.skull.black": "Црна фигура на череп",
  "block.minecraft.banner.skull.blue": "Сина фигура на череп",
  "block.minecraft.banner.skull.brown": "Кафеава фигура на череп",
  "block.minecraft.banner.skull.cyan": "Сино-зелена фигура на череп",
  "block.minecraft.banner.skull.gray": "Сива фигура на череп",
  "block.minecraft.banner.skull.green": "Зелена фигура на череп",
  "block.minecraft.banner.skull.light_blue": "Светлосина фигура на череп",
  "block.minecraft.banner.skull.light_gray": "Светлосива фигура на череп",
  "block.minecraft.banner.skull.lime": "Жолто-зелена фигура на череп",
  "block.minecraft.banner.skull.magenta": "Магента фигура на череп",
  "block.minecraft.banner.skull.orange": "Портокалова фигура на череп",
  "block.minecraft.banner.skull.pink": "Розова фигура на череп",
  "block.minecraft.banner.skull.purple": "Виолетова фигура на череп",
  "block.minecraft.banner.skull.red": "Црвена фигура на череп",
  "block.minecraft.banner.skull.white": "Бела фигура на череп",
  "block.minecraft.banner.skull.yellow": "Жолта фигура на череп",
  "block.minecraft.banner.small_stripes.black": "Црни вертикални ленти",
  "block.minecraft.banner.small_stripes.blue": "Сини вертикални ленти",
  "block.minecraft.banner.small_stripes.brown": "Кафеави вертикални ленти",
  "block.minecraft.banner.small_stripes.cyan": "Сино-зелени вертикални ленти",
  "block.minecraft.banner.small_stripes.gray": "Сиви вертикални ленти",
  "block.minecraft.banner.small_stripes.green": "Зелени вертикални ленти",
  "block.minecraft.banner.small_stripes.light_blue": "Светлосини вертикални ленти",
  "block.minecraft.banner.small_stripes.light_gray": "Светлосиви вертикални ленти",
  "block.minecraft.banner.small_stripes.lime": "Жолто-зелени вертикални ленти",
  "block.minecraft.banner.small_stripes.magenta": "Магента вертикални ленти",
  "block.minecraft.banner.small_stripes.orange": "Портокалови вертикални ленти",
  "block.minecraft.banner.small_stripes.pink": "Розови вертикални ленти",
  "block.minecraft.banner.small_stripes.purple": "Виолетови вертикални ленти",
  "block.minecraft.banner.small_stripes.red": "Црвени вертикални ленти",
  "block.minecraft.banner.small_stripes.white": "Бели вертикални ленти",
  "block.minecraft.banner.small_stripes.yellow": "Жолти вертикални ленти",
  "block.minecraft.banner.square_bottom_left.black": "Црн долен лев кантон",
  "block.minecraft.banner.square_bottom_left.blue": "Син долен лев кантон",
  "block.minecraft.banner.square_bottom_left.brown": "Кафеав долен лев кантон",
  "block.minecraft.banner.square_bottom_left.cyan": "Сино-зелен долен лев кантон",
  "block.minecraft.banner.square_bottom_left.gray": "Сив долен лев кантон",
  "block.minecraft.banner.square_bottom_left.green": "Зелен долен лев кантон",
  "block.minecraft.banner.square_bottom_left.light_blue": "Светлосив долен лев кантон",
  "block.minecraft.banner.square_bottom_left.light_gray": "Светлосив долен лев кантон",
  "block.minecraft.banner.square_bottom_left.lime": "Лиметен долен лев кантон",
  "block.minecraft.banner.square_bottom_left.magenta": "Магента долен лев кантон",
  "block.minecraft.banner.square_bottom_left.orange": "Портокалов долен лев кантон",
  "block.minecraft.banner.square_bottom_left.pink": "Розов долен лев кантон",
  "block.minecraft.banner.square_bottom_left.purple": "Виолетов долен лев кантон",
  "block.minecraft.banner.square_bottom_left.red": "Црвен долен лев кантон",
  "block.minecraft.banner.square_bottom_left.white": "Бел долен лев кантон",
  "block.minecraft.banner.square_bottom_left.yellow": "Жолт долен лев кантон",
  "block.minecraft.banner.square_bottom_right.black": "Црн долен десен кантон",
  "block.minecraft.banner.square_bottom_right.blue": "Син долен десен кантон",
  "block.minecraft.banner.square_bottom_right.brown": "Кафеав долен десен кантон",
  "block.minecraft.banner.square_bottom_right.cyan": "Сино-зелен долен десен кантон",
  "block.minecraft.banner.square_bottom_right.gray": "Сив долен десен кантон",
  "block.minecraft.banner.square_bottom_right.green": "Зелен долен десен кантон",
  "block.minecraft.banner.square_bottom_right.light_blue": "Светлосив долен десен кантон",
  "block.minecraft.banner.square_bottom_right.light_gray": "Светлосив долен десен кантон",
  "block.minecraft.banner.square_bottom_right.lime": "Жолто-зелен долен десен кантон",
  "block.minecraft.banner.square_bottom_right.magenta": "Магента долен десен кантон",
  "block.minecraft.banner.square_bottom_right.orange": "Портокалов долен десен кантон",
  "block.minecraft.banner.square_bottom_right.pink": "Розов долен десен кантон",
  "block.minecraft.banner.square_bottom_right.purple": "Виолетов долен десен кантон",
  "block.minecraft.banner.square_bottom_right.red": "Црвен долен десен кантон",
  "block.minecraft.banner.square_bottom_right.white": "Бел долен десен кантон",
  "block.minecraft.banner.square_bottom_right.yellow": "Жолт долен десен кантон",
  "block.minecraft.banner.square_top_left.black": "Црн горен лев кантон",
  "block.minecraft.banner.square_top_left.blue": "Син горен лев кантон",
  "block.minecraft.banner.square_top_left.brown": "Кафеав горен лев кантон",
  "block.minecraft.banner.square_top_left.cyan": "Сино-зелен горен лев кантон",
  "block.minecraft.banner.square_top_left.gray": "Сив горен лев кантон",
  "block.minecraft.banner.square_top_left.green": "Зелен горен лев кантон",
  "block.minecraft.banner.square_top_left.light_blue": "Светлосин горен лев кантон",
  "block.minecraft.banner.square_top_left.light_gray": "Светлосив горен лев кантон",
  "block.minecraft.banner.square_top_left.lime": "Жолто-зелен горен лев кантон",
  "block.minecraft.banner.square_top_left.magenta": "Магента горен лев кантон",
  "block.minecraft.banner.square_top_left.orange": "Портокалов горен лев кантон",
  "block.minecraft.banner.square_top_left.pink": "Розов горен лев кантон",
  "block.minecraft.banner.square_top_left.purple": "Виолетов горен лев кантон",
  "block.minecraft.banner.square_top_left.red": "Црвен горен лев кантон",
  "block.minecraft.banner.square_top_left.white": "Бел горен лев кантон",
  "block.minecraft.banner.square_top_left.yellow": "Жолт горен лев кантон",
  "block.minecraft.banner.square_top_right.black": "Црн горен десен кантон",
  "block.minecraft.banner.square_top_right.blue": "Син горен десен кантон",
  "block.minecraft.banner.square_top_right.brown": "Кафеав горен десен кантон",
  "block.minecraft.banner.square_top_right.cyan": "Сино-зелен горен десен кантон",
  "block.minecraft.banner.square_top_right.gray": "Сив горен десен кантон",
  "block.minecraft.banner.square_top_right.green": "Зелен горен десен кантон",
  "block.minecraft.banner.square_top_right.light_blue": "Светлосин горен десен кантон",
  "block.minecraft.banner.square_top_right.light_gray": "Светлосив горен десен кантон",
  "block.minecraft.banner.square_top_right.lime": "Жолто-зелен горен десен кантон",
  "block.minecraft.banner.square_top_right.magenta": "Магента горен десен кантон",
  "block.minecraft.banner.square_top_right.orange": "Портокалов горен десен кантон",
  "block.minecraft.banner.square_top_right.pink": "Розов горен десен кантон",
  "block.minecraft.banner.square_top_right.purple": "Виолетов горен десен кантон",
  "block.minecraft.banner.square_top_right.red": "Црвен горен десен кантон",
  "block.minecraft.banner.square_top_right.white": "Бел горен десен кантон",
  "block.minecraft.banner.square_top_right.yellow": "Жолт горен десен кантон",
  "block.minecraft.banner.straight_cross.black": "Црн крст",
  "block.minecraft.banner.straight_cross.blue": "Син крст",
  "block.minecraft.banner.straight_cross.brown": "Кафеав крст",
  "block.minecraft.banner.straight_cross.cyan": "Сино-зелен крст",
  "block.minecraft.banner.straight_cross.gray": "Сив крст",
  "block.minecraft.banner.straight_cross.green": "Зелен крст",
  "block.minecraft.banner.straight_cross.light_blue": "Светлосин крст",
  "block.minecraft.banner.straight_cross.light_gray": "Светлосив крст",
  "block.minecraft.banner.straight_cross.lime": "Жолто-зелен крст",
  "block.minecraft.banner.straight_cross.magenta": "Магента крст",
  "block.minecraft.banner.straight_cross.orange": "Портокалов крст",
  "block.minecraft.banner.straight_cross.pink": "Розов крст",
  "block.minecraft.banner.straight_cross.purple": "Виолетов крст",
  "block.minecraft.banner.straight_cross.red": "Црвен крст",
  "block.minecraft.banner.straight_cross.white": "Бел крст",
  "block.minecraft.banner.straight_cross.yellow": "Жолт крст",
  "block.minecraft.banner.stripe_bottom.black": "Црн долен дел",
  "block.minecraft.banner.stripe_bottom.blue": "Син долен дел",
  "block.minecraft.banner.stripe_bottom.brown": "Кафеав долен дел",
  "block.minecraft.banner.stripe_bottom.cyan": "Сино-зелен долен дел",
  "block.minecraft.banner.stripe_bottom.gray": "Сив долен дел",
  "block.minecraft.banner.stripe_bottom.green": "Зелен долен дел",
  "block.minecraft.banner.stripe_bottom.light_blue": "Светлосин долен дел",
  "block.minecraft.banner.stripe_bottom.light_gray": "Светлосив долен дел",
  "block.minecraft.banner.stripe_bottom.lime": "Жолто-зелен долен дел",
  "block.minecraft.banner.stripe_bottom.magenta": "Магента долен дел",
  "block.minecraft.banner.stripe_bottom.orange": "Портокалов долен дел",
  "block.minecraft.banner.stripe_bottom.pink": "Розов долен дел",
  "block.minecraft.banner.stripe_bottom.purple": "Виолетов долен дел",
  "block.minecraft.banner.stripe_bottom.red": "Црвен долен дел",
  "block.minecraft.banner.stripe_bottom.white": "Бел долен дел",
  "block.minecraft.banner.stripe_bottom.yellow": "Жолт долен дел",
  "block.minecraft.banner.stripe_center.black": "Црна вертикална лента",
  "block.minecraft.banner.stripe_center.blue": "Сина вертикална лента",
  "block.minecraft.banner.stripe_center.brown": "Кафеава вертикална лента",
  "block.minecraft.banner.stripe_center.cyan": "Сино-зелена вертикална лента",
  "block.minecraft.banner.stripe_center.gray": "Сива вертикална лента",
  "block.minecraft.banner.stripe_center.green": "Зелена вертикална лента",
  "block.minecraft.banner.stripe_center.light_blue": "Светлосина вертикална лента",
  "block.minecraft.banner.stripe_center.light_gray": "Светлосива вертикална лента",
  "block.minecraft.banner.stripe_center.lime": "Жолто-зелена вертикална лента",
  "block.minecraft.banner.stripe_center.magenta": "Магента вертикална лента",
  "block.minecraft.banner.stripe_center.orange": "Портокалова вертикална лента",
  "block.minecraft.banner.stripe_center.pink": "Розова вертикална лента",
  "block.minecraft.banner.stripe_center.purple": "Виолетова вертикална лента",
  "block.minecraft.banner.stripe_center.red": "Црвена вертикална лента",
  "block.minecraft.banner.stripe_center.white": "Бела вертикална лента",
  "block.minecraft.banner.stripe_center.yellow": "Жолта вертикална лента",
  "block.minecraft.banner.stripe_downleft.black": "Црна дијагонала од десно кон лево",
  "block.minecraft.banner.stripe_downleft.blue": "Сина дијагонала од десно кон лево",
  "block.minecraft.banner.stripe_downleft.brown": "Кафеава дијагонала од десно кон лево",
  "block.minecraft.banner.stripe_downleft.cyan": "Сино-зелена дијагонала од десно кон лево",
  "block.minecraft.banner.stripe_downleft.gray": "Сива дијагонала од десно кон лево",
  "block.minecraft.banner.stripe_downleft.green": "Зелена дијагонала од десно кон лево",
  "block.minecraft.banner.stripe_downleft.light_blue": "Светлосина дијагонала од десно кон лево",
  "block.minecraft.banner.stripe_downleft.light_gray": "Светлосива дијагонала од десно кон лево",
  "block.minecraft.banner.stripe_downleft.lime": "Жолто-зелена дијагонала од десно кон лево",
  "block.minecraft.banner.stripe_downleft.magenta": "Магента дијагонала од десно кон лево",
  "block.minecraft.banner.stripe_downleft.orange": "Портокалова дијагонала од десно кон лево",
  "block.minecraft.banner.stripe_downleft.pink": "Розова дијагонала од десно кон лево",
  "block.minecraft.banner.stripe_downleft.purple": "Виолетова дијагонала од десно кон лево",
  "block.minecraft.banner.stripe_downleft.red": "Црвена дијагонала од десно кон лево",
  "block.minecraft.banner.stripe_downleft.white": "Бела дијагонала од десно кон лево",
  "block.minecraft.banner.stripe_downleft.yellow": "Жолта дијагонала од десно кон лево",
  "block.minecraft.banner.stripe_downright.black": "Црна дијагонала од лево кон десно",
  "block.minecraft.banner.stripe_downright.blue": "Сина дијагонала од лево кон десно",
  "block.minecraft.banner.stripe_downright.brown": "Кафеава дијагонала од лево кон десно",
  "block.minecraft.banner.stripe_downright.cyan": "Сино-зелена дијагонала од лево кон десно",
  "block.minecraft.banner.stripe_downright.gray": "Сива дијагонала од лево кон десно",
  "block.minecraft.banner.stripe_downright.green": "Зелена дијагонала од лево кон десно",
  "block.minecraft.banner.stripe_downright.light_blue": "Светлосина дијагонала од лево кон десно",
  "block.minecraft.banner.stripe_downright.light_gray": "Светлосива дијагонала од лево кон десно",
  "block.minecraft.banner.stripe_downright.lime": "Жолто-зелена дијагонала од лево кон десно",
  "block.minecraft.banner.stripe_downright.magenta": "Магента дијагонала од лево кон десно",
  "block.minecraft.banner.stripe_downright.orange": "Портокалова дијагонала од лево кон десно",
  "block.minecraft.banner.stripe_downright.pink": "Розова дијагонала од лево кон десно",
  "block.minecraft.banner.stripe_downright.purple": "Виолетова дијагонала од лево кон десно",
  "block.minecraft.banner.stripe_downright.red": "Црвена дијагонала од лево кон десно",
  "block.minecraft.banner.stripe_downright.white": "Бела дијагонала од лево кон десно",
  "block.minecraft.banner.stripe_downright.yellow": "Жолта дијагонала од лево кон десно",
  "block.minecraft.banner.stripe_left.black": "Црна лева лента",
  "block.minecraft.banner.stripe_left.blue": "Сина лева лента",
  "block.minecraft.banner.stripe_left.brown": "Кафеава лева лента",
  "block.minecraft.banner.stripe_left.cyan": "Сино-зелена лева лента",
  "block.minecraft.banner.stripe_left.gray": "Сива лева лента",
  "block.minecraft.banner.stripe_left.green": "Зелена лева лента",
  "block.minecraft.banner.stripe_left.light_blue": "Светлосина лева лента",
  "block.minecraft.banner.stripe_left.light_gray": "Светлосива лева лента",
  "block.minecraft.banner.stripe_left.lime": "Жолто-зелена лева лента",
  "block.minecraft.banner.stripe_left.magenta": "Магента лева лента",
  "block.minecraft.banner.stripe_left.orange": "Портокалова лева лента",
  "block.minecraft.banner.stripe_left.pink": "Розова лева лента",
  "block.minecraft.banner.stripe_left.purple": "Виолетова лева лента",
  "block.minecraft.banner.stripe_left.red": "Црвена лева лента",
  "block.minecraft.banner.stripe_left.white": "Бела лева лента",
  "block.minecraft.banner.stripe_left.yellow": "Жолта лева лента",
  "block.minecraft.banner.stripe_middle.black": "Црна хоризонтална лента",
  "block.minecraft.banner.stripe_middle.blue": "Сина хоризонтална лента",
  "block.minecraft.banner.stripe_middle.brown": "Кафеава хоризонтална лента",
  "block.minecraft.banner.stripe_middle.cyan": "Сино-зелена хоризонтална лента",
  "block.minecraft.banner.stripe_middle.gray": "Сива хоризонтална лента",
  "block.minecraft.banner.stripe_middle.green": "Зелена хоризонтална лента",
  "block.minecraft.banner.stripe_middle.light_blue": "Светлосина хоризонтална лента",
  "block.minecraft.banner.stripe_middle.light_gray": "Светлосива хоризонтална лента",
  "block.minecraft.banner.stripe_middle.lime": "Жолто-зелена хоризонтална лента",
  "block.minecraft.banner.stripe_middle.magenta": "Магента хоризонтална лента",
  "block.minecraft.banner.stripe_middle.orange": "Портокалова хоризонтална лента",
  "block.minecraft.banner.stripe_middle.pink": "Розова хоризонтална лента",
  "block.minecraft.banner.stripe_middle.purple": "Виолетова хоризонтална лента",
  "block.minecraft.banner.stripe_middle.red": "Црвена хоризонтална лента",
  "block.minecraft.banner.stripe_middle.white": "Бела хоризонтална лента",
  "block.minecraft.banner.stripe_middle.yellow": "Жолта хоризонтална лента",
  "block.minecraft.banner.stripe_right.black": "Црна десна лента",
  "block.minecraft.banner.stripe_right.blue": "Сина десна лента",
  "block.minecraft.banner.stripe_right.brown": "Кафеава десна лента",
  "block.minecraft.banner.stripe_right.cyan": "Сино-зелена десна лента",
  "block.minecraft.banner.stripe_right.gray": "Сива десна лента",
  "block.minecraft.banner.stripe_right.green": "Зелена десна лента",
  "block.minecraft.banner.stripe_right.light_blue": "Светлосина десна лента",
  "block.minecraft.banner.stripe_right.light_gray": "Светлосива десна лента",
  "block.minecraft.banner.stripe_right.lime": "Жолто-зелена десна лента",
  "block.minecraft.banner.stripe_right.magenta": "Магента десна лента",
  "block.minecraft.banner.stripe_right.orange": "Портокалова десна лента",
  "block.minecraft.banner.stripe_right.pink": "Розова десна лента",
  "block.minecraft.banner.stripe_right.purple": "Виолетова десна лента",
  "block.minecraft.banner.stripe_right.red": "Црвена десна лента",
  "block.minecraft.banner.stripe_right.white": "Бела десна лента",
  "block.minecraft.banner.stripe_right.yellow": "Жолта десна лента",
  "block.minecraft.banner.stripe_top.black": "Црн горен дел",
  "block.minecraft.banner.stripe_top.blue": "Син горен дел",
  "block.minecraft.banner.stripe_top.brown": "Кафеав горен дел",
  "block.minecraft.banner.stripe_top.cyan": "Сино-зелен горен дел",
  "block.minecraft.banner.stripe_top.gray": "Сив горен дел",
  "block.minecraft.banner.stripe_top.green": "Зелен горен дел",
  "block.minecraft.banner.stripe_top.light_blue": "Светлосин горен дел",
  "block.minecraft.banner.stripe_top.light_gray": "Светлосив горен дел",
  "block.minecraft.banner.stripe_top.lime": "Жолто-зелен горен дел",
  "block.minecraft.banner.stripe_top.magenta": "Магента горен дел",
  "block.minecraft.banner.stripe_top.orange": "Портокалов горен дел",
  "block.minecraft.banner.stripe_top.pink": "Розов горен дел",
  "block.minecraft.banner.stripe_top.purple": "Виолетов горен дел",
  "block.minecraft.banner.stripe_top.red": "Црвен горен дел",
  "block.minecraft.banner.stripe_top.white": "Бел горен дел",
  "block.minecraft.banner.stripe_top.yellow": "Жолт горен дел",
  "block.minecraft.banner.triangle_bottom.black": "Црн долен триаголник",
  "block.minecraft.banner.triangle_bottom.blue": "Син долен триаголник",
  "block.minecraft.banner.triangle_bottom.brown": "Кафеав долен триаголник",
  "block.minecraft.banner.triangle_bottom.cyan": "Сино-зелен долен триаголник",
  "block.minecraft.banner.triangle_bottom.gray": "Сив долен триаголник",
  "block.minecraft.banner.triangle_bottom.green": "Зелен долен триаголник",
  "block.minecraft.banner.triangle_bottom.light_blue": "Светлосин долен триаголник",
  "block.minecraft.banner.triangle_bottom.light_gray": "Светлосив долен триаголник",
  "block.minecraft.banner.triangle_bottom.lime": "Жолто-зелен долен триаголник",
  "block.minecraft.banner.triangle_bottom.magenta": "Магента долен триаголник",
  "block.minecraft.banner.triangle_bottom.orange": "Портокалов долен триаголник",
  "block.minecraft.banner.triangle_bottom.pink": "Розов долен триаголник",
  "block.minecraft.banner.triangle_bottom.purple": "Виолетов долен триаголник",
  "block.minecraft.banner.triangle_bottom.red": "Црвен долен триаголник",
  "block.minecraft.banner.triangle_bottom.white": "Бел долен триаголник",
  "block.minecraft.banner.triangle_bottom.yellow": "Жолт долен триаголник",
  "block.minecraft.banner.triangle_top.black": "Црн горен триаголник",
  "block.minecraft.banner.triangle_top.blue": "Син горен триаголник",
  "block.minecraft.banner.triangle_top.brown": "Кафеав горен триаголник",
  "block.minecraft.banner.triangle_top.cyan": "Сино-зелен горен триаголник",
  "block.minecraft.banner.triangle_top.gray": "Сив горен триаголник",
  "block.minecraft.banner.triangle_top.green": "Зелен горен триаголник",
  "block.minecraft.banner.triangle_top.light_blue": "Светлосин горен триаголник",
  "block.minecraft.banner.triangle_top.light_gray": "Светлосив горен триаголник",
  "block.minecraft.banner.triangle_top.lime": "Жолто-зелен горен триаголник",
  "block.minecraft.banner.triangle_top.magenta": "Магента горен триаголник",
  "block.minecraft.banner.triangle_top.orange": "Портокалов горен триаголник",
  "block.minecraft.banner.triangle_top.pink": "Розов горен триаголник",
  "block.minecraft.banner.triangle_top.purple": "Виолетов горен триаголник",
  "block.minecraft.banner.triangle_top.red": "Црвен горен триаголник",
  "block.minecraft.banner.triangle_top.white": "Бел горен триаголник",
  "block.minecraft.banner.triangle_top.yellow": "Жолт горен триаголник",
  "block.minecraft.banner.triangles_bottom.black": "Црни долни запци",
  "block.minecraft.banner.triangles_bottom.blue": "Сини долни запци",
  "block.minecraft.banner.triangles_bottom.brown": "Кафеави долни запци",
  "block.minecraft.banner.triangles_bottom.cyan": "Сино-зелени долни запци",
  "block.minecraft.banner.triangles_bottom.gray": "Сиви долни запци",
  "block.minecraft.banner.triangles_bottom.green": "Зелени долни запци",
  "block.minecraft.banner.triangles_bottom.light_blue": "Светлосини долни запци",
  "block.minecraft.banner.triangles_bottom.light_gray": "Светлосиви долни запци",
  "block.minecraft.banner.triangles_bottom.lime": "Жолто-зелени долни запци",
  "block.minecraft.banner.triangles_bottom.magenta": "Магента долни запци",
  "block.minecraft.banner.triangles_bottom.orange": "Портокалови долни запци",
  "block.minecraft.banner.triangles_bottom.pink": "Розови долни запци",
  "block.minecraft.banner.triangles_bottom.purple": "Виолетови долни запци",
  "block.minecraft.banner.triangles_bottom.red": "Црвени долни запци",
  "block.minecraft.banner.triangles_bottom.white": "Бели долни запци",
  "block.minecraft.banner.triangles_bottom.yellow": "Жолти долни запци",
  "block.minecraft.banner.triangles_top.black": "Црни горни запци",
  "block.minecraft.banner.triangles_top.blue": "Сини горни запци",
  "block.minecraft.banner.triangles_top.brown": "Кафеави горни запци",
  "block.minecraft.banner.triangles_top.cyan": "Сино-зелени горни запци",
  "block.minecraft.banner.triangles_top.gray": "Сиви горни запци",
  "block.minecraft.banner.triangles_top.green": "Зелени горни запци",
  "block.minecraft.banner.triangles_top.light_blue": "Светлосини горни запци",
  "block.minecraft.banner.triangles_top.light_gray": "Светлосиви горни запци",
  "block.minecraft.banner.triangles_top.lime": "Жолто-зелени горни запци",
  "block.minecraft.banner.triangles_top.magenta": "Магента горни запци",
  "block.minecraft.banner.triangles_top.orange": "Портокалови горни запци",
  "block.minecraft.banner.triangles_top.pink": "Розови горни запци",
  "block.minecraft.banner.triangles_top.purple": "Виолетови горни запци",
  "block.minecraft.banner.triangles_top.red": "Црвени горни запци",
  "block.minecraft.banner.triangles_top.white": "Бели горни запци",
  "block.minecraft.banner.triangles_top.yellow": "Жолти горни запци",
  "block.minecraft.barrel": "Буре",
  "block.minecraft.barrier": "Бариера",
  "block.minecraft.basalt": "Базалт",
  "block.minecraft.beacon": "Светилник",
  "block.minecraft.beacon.primary": "Примарна моќ",
  "block.minecraft.beacon.secondary": "Секундарна моќ",
  "block.minecraft.bed.no_sleep": "Можеш само да спиеш кога е вечер или додега грми",
  "block.minecraft.bed.not_safe": "Не можеш да одмараш сега; има чудовишта во близина",
  "block.minecraft.bed.obstructed": "Достапот до креветот е попречен",
  "block.minecraft.bed.occupied": "Креветот е зафатен",
  "block.minecraft.bed.too_far_away": "Не можеш да одмараш сега; креветот е предалеку",
  "block.minecraft.bedrock": "Темел",
  "block.minecraft.bee_nest": "Гнездо на пчели",
  "block.minecraft.beehive": "Пчеларник",
  "block.minecraft.beetroots": "Цвекло",
  "block.minecraft.bell": "Ѕвонче",
  "block.minecraft.big_dripleaf": "Голем Каплист",
  "block.minecraft.big_dripleaf_stem": "Голем Матични Каплист",
  "block.minecraft.birch_button": "Копче од бреза",
  "block.minecraft.birch_door": "Врата од бреза",
  "block.minecraft.birch_fence": "Ограда од бреза",
  "block.minecraft.birch_fence_gate": "Врата за ограда од бреза",
  "block.minecraft.birch_hanging_sign": "Брезен висечки знак",
  "block.minecraft.birch_leaves": "Лисја од бреза",
  "block.minecraft.birch_log": "Труп од бреза",
  "block.minecraft.birch_planks": "Даски од бреза",
  "block.minecraft.birch_pressure_plate": "Притисна плоча од бреза",
  "block.minecraft.birch_sapling": "Фиданка од бреза",
  "block.minecraft.birch_shelf": "Birch Shelf",
  "block.minecraft.birch_sign": "Знак од бреза",
  "block.minecraft.birch_slab": "Плоча од бреза",
  "block.minecraft.birch_stairs": "Скали од бреза",
  "block.minecraft.birch_trapdoor": "Врата-стапица од бреза",
  "block.minecraft.birch_wall_hanging_sign": "Висечки знак од бреза",
  "block.minecraft.birch_wall_sign": "Ѕиден знак од бреза",
  "block.minecraft.birch_wood": "Бреза",
  "block.minecraft.black_banner": "Црн банер",
  "block.minecraft.black_bed": "Црн кревет",
  "block.minecraft.black_candle": "Црна свеќа",
  "block.minecraft.black_candle_cake": "Торта со Црна Свеќа",
  "block.minecraft.black_carpet": "Црн тепих",
  "block.minecraft.black_concrete": "Црн бетон",
  "block.minecraft.black_concrete_powder": "Црн бетон во прав",
  "block.minecraft.black_glazed_terracotta": "Црна глазирана теракота",
  "block.minecraft.black_shulker_box": "Црна шулкер кутија",
  "block.minecraft.black_stained_glass": "Црно стакло",
  "block.minecraft.black_stained_glass_pane": "Црна стаклена рамка",
  "block.minecraft.black_terracotta": "Црна теракота",
  "block.minecraft.black_wool": "Црна волна",
  "block.minecraft.blackstone": "Црн Камен",
  "block.minecraft.blackstone_slab": "Плочка од Црн Камен",
  "block.minecraft.blackstone_stairs": "Скали од Црн Камен",
  "block.minecraft.blackstone_wall": "Sид од Црн Камен",
  "block.minecraft.blast_furnace": "Висока печка",
  "block.minecraft.blue_banner": "Син банер",
  "block.minecraft.blue_bed": "Син кревет",
  "block.minecraft.blue_candle": "Сина свеќа",
  "block.minecraft.blue_candle_cake": "Торта со Сина Свеќа",
  "block.minecraft.blue_carpet": "Син тепих",
  "block.minecraft.blue_concrete": "Син бетон",
  "block.minecraft.blue_concrete_powder": "Син бетон во прав",
  "block.minecraft.blue_glazed_terracotta": "Сина глазирана теракота",
  "block.minecraft.blue_ice": "Син мраз",
  "block.minecraft.blue_orchid": "Сина орхидеја",
  "block.minecraft.blue_shulker_box": "Сина шулкер кутија",
  "block.minecraft.blue_stained_glass": "Сино стакло",
  "block.minecraft.blue_stained_glass_pane": "Сина стаклена рамка",
  "block.minecraft.blue_terracotta": "Сина теракота",
  "block.minecraft.blue_wool": "Сина волна",
  "block.minecraft.bone_block": "Блок од коска",
  "block.minecraft.bookshelf": "Полица за книги",
  "block.minecraft.brain_coral": "Мозочен корал",
  "block.minecraft.brain_coral_block": "Мозочен корален блок",
  "block.minecraft.brain_coral_fan": "Мозочна корална лепеза",
  "block.minecraft.brain_coral_wall_fan": "Ѕидна мозочна корална лепеза",
  "block.minecraft.brewing_stand": "Штанд за напивки",
  "block.minecraft.brick_slab": "Циглена плоча",
  "block.minecraft.brick_stairs": "Скали од цигли",
  "block.minecraft.brick_wall": "Ѕид од цигли",
  "block.minecraft.bricks": "Цигли",
  "block.minecraft.brown_banner": "Кафеав банер",
  "block.minecraft.brown_bed": "Кафеав Кревет",
  "block.minecraft.brown_candle": "Кафеава свеќа",
  "block.minecraft.brown_candle_cake": "Торта со Кафена Свеќа",
  "block.minecraft.brown_carpet": "Кафеав тепих",
  "block.minecraft.brown_concrete": "Кафеав бетон",
  "block.minecraft.brown_concrete_powder": "Кафеав бетон во прав",
  "block.minecraft.brown_glazed_terracotta": "Кафеава глазирана теракота",
  "block.minecraft.brown_mushroom": "Кафеава печурка",
  "block.minecraft.brown_mushroom_block": "Блок од кафеава печурка",
  "block.minecraft.brown_shulker_box": "Кафеава шулкер кутија",
  "block.minecraft.brown_stained_glass": "Кафеаво стакло",
  "block.minecraft.brown_stained_glass_pane": "Кафеава стаклена рамка",
  "block.minecraft.brown_terracotta": "Кафеава теракота",
  "block.minecraft.brown_wool": "Кафеава волна",
  "block.minecraft.bubble_column": "Меурчест столб",
  "block.minecraft.bubble_coral": "Меурчест корал",
  "block.minecraft.bubble_coral_block": "Меурчест корален блок",
  "block.minecraft.bubble_coral_fan": "Меурчеста корална лепеза",
  "block.minecraft.bubble_coral_wall_fan": "Ѕидна меурчеста корална лепеза",
  "block.minecraft.budding_amethyst": "Младиот и надежен аметист",
  "block.minecraft.bush": "Грмушка",
  "block.minecraft.cactus": "Кактус",
  "block.minecraft.cactus_flower": "Cactus Flower",
  "block.minecraft.cake": "Торта",
  "block.minecraft.calcite": "Калцит",
  "block.minecraft.calibrated_sculk_sensor": "Calibrated Sculk Sensor",
  "block.minecraft.campfire": "Логорски оган",
  "block.minecraft.candle": "Свеќа",
  "block.minecraft.candle_cake": "Торта со свеќа",
  "block.minecraft.carrots": "Моркови",
  "block.minecraft.cartography_table": "Картографска маса",
  "block.minecraft.carved_pumpkin": "Врежана тиква",
  "block.minecraft.cauldron": "Котел",
  "block.minecraft.cave_air": "Пештерски воздух",
  "block.minecraft.cave_vines": "Пештерана лоза",
  "block.minecraft.cave_vines_plant": "Пештерска билка",
  "block.minecraft.chain": "Верижен",
  "block.minecraft.chain_command_block": "Верижен команден блок",
  "block.minecraft.cherry_button": "Копче од цреша",
  "block.minecraft.cherry_door": "Цреша врата",
  "block.minecraft.cherry_fence": "Ограда од цреша",
  "block.minecraft.cherry_fence_gate": "Порта за ограда од цреша",
  "block.minecraft.cherry_hanging_sign": "Знак за виси цреша",
  "block.minecraft.cherry_leaves": "Лисја од цреша",
  "block.minecraft.cherry_log": "Дневник на цреша",
  "block.minecraft.cherry_planks": "Цреша штици",
  "block.minecraft.cherry_pressure_plate": "Плоча под притисок на цреша",
  "block.minecraft.cherry_sapling": "Фиданка од цреша",
  "block.minecraft.cherry_shelf": "Cherry Shelf",
  "block.minecraft.cherry_sign": "Знак цреша",
  "block.minecraft.cherry_slab": "Цреша плоча",
  "block.minecraft.cherry_stairs": "Цреша скали",
  "block.minecraft.cherry_trapdoor": "Cherry Trapdoor",
  "block.minecraft.cherry_wall_hanging_sign": "Знак за виси ѕид од цреша",
  "block.minecraft.cherry_wall_sign": "Знак за ѕид од цреша",
  "block.minecraft.cherry_wood": "Црешово дрво",
  "block.minecraft.chest": "Сандак",
  "block.minecraft.chipped_anvil": "Поткршена наковална",
  "block.minecraft.chiseled_bookshelf": "Издлабена полица за книги",
  "block.minecraft.chiseled_copper": "Chiseled Copper",
  "block.minecraft.chiseled_deepslate": "Исклесан шкрилец",
  "block.minecraft.chiseled_nether_bricks": "Изработени Пеколски Цигли",
  "block.minecraft.chiseled_polished_blackstone": "Изработен Размазен Црн Камен",
  "block.minecraft.chiseled_quartz_block": "Коцка од длетуван кварц",
  "block.minecraft.chiseled_red_sandstone": "Длетуван црвен песочник",
  "block.minecraft.chiseled_resin_bricks": "Chiseled Resin Bricks",
  "block.minecraft.chiseled_sandstone": "Длетуван песочник",
  "block.minecraft.chiseled_stone_bricks": "Длетувани камени цигли",
  "block.minecraft.chiseled_tuff": "Chiseled Tuff",
  "block.minecraft.chiseled_tuff_bricks": "Chiseled Tuff Bricks",
  "block.minecraft.chorus_flower": "Хорус цвет",
  "block.minecraft.chorus_plant": "Хорус растение",
  "block.minecraft.clay": "Глина",
  "block.minecraft.closed_eyeblossom": "Closed Eyeblossom",
  "block.minecraft.coal_block": "Блок од јаглен",
  "block.minecraft.coal_ore": "Јагленова руда",
  "block.minecraft.coarse_dirt": "Груба земја",
  "block.minecraft.cobbled_deepslate": "Калдрмаст шкрилец",
  "block.minecraft.cobbled_deepslate_slab": "Плоча од калдрмаст шкрилец",
  "block.minecraft.cobbled_deepslate_stairs": "Сакли од калдрмаст шкрилец",
  "block.minecraft.cobbled_deepslate_wall": "Зид од калдрмаст шкрилец",
  "block.minecraft.cobblestone": "Калдрма",
  "block.minecraft.cobblestone_slab": "Плоча од калдрма",
  "block.minecraft.cobblestone_stairs": "Скали од калдрма",
  "block.minecraft.cobblestone_wall": "Ѕид од калдрма",
  "block.minecraft.cobweb": "Пајажина",
  "block.minecraft.cocoa": "Какао",
  "block.minecraft.command_block": "Команден блок",
  "block.minecraft.comparator": "Редстоун споредник",
  "block.minecraft.composter": "Компостер",
  "block.minecraft.conduit": "Подводна клетка",
  "block.minecraft.copper_bars": "Copper Bars",
  "block.minecraft.copper_block": "Блок од бакар",
  "block.minecraft.copper_bulb": "Copper Bulb",
  "block.minecraft.copper_chain": "Copper Chain",
  "block.minecraft.copper_chest": "Copper Chest",
  "block.minecraft.copper_door": "Copper Door",
  "block.minecraft.copper_golem_statue": "Copper Golem Statue",
  "block.minecraft.copper_grate": "Copper Grate",
  "block.minecraft.copper_lantern": "Copper Lantern",
  "block.minecraft.copper_ore": "Бакарна руда",
  "block.minecraft.copper_torch": "Copper Torch",
  "block.minecraft.copper_trapdoor": "Copper Trapdoor",
  "block.minecraft.copper_wall_torch": "Copper Wall Torch",
  "block.minecraft.cornflower": "Модрика",
  "block.minecraft.cracked_deepslate_bricks": "Пукнати шкрилести цигли",
  "block.minecraft.cracked_deepslate_tiles": "Пукнати шкрилести плочки",
  "block.minecraft.cracked_nether_bricks": "Пукнати Пеколски Цигли",
  "block.minecraft.cracked_polished_blackstone_bricks": "Пукнати Размазени Цигли од Црн Камен",
  "block.minecraft.cracked_stone_bricks": "Напукнати камени цигли",
  "block.minecraft.crafter": "Crafter",
  "block.minecraft.crafting_table": "Работна маса",
  "block.minecraft.creaking_heart": "Creaking Heart",
  "block.minecraft.creeper_head": "Глава од крипер",
  "block.minecraft.creeper_wall_head": "Ѕидна глава од крипер",
  "block.minecraft.crimson_button": "Црвено Копче",
  "block.minecraft.crimson_door": "Црвена Врата",
  "block.minecraft.crimson_fence": "Црвена Ограда",
  "block.minecraft.crimson_fence_gate": "Црвена Порта",
  "block.minecraft.crimson_fungus": "Црвен Корен",
  "block.minecraft.crimson_hanging_sign": "Темноцрвен висечки знак",
  "block.minecraft.crimson_hyphae": "Црвени Хифи",
  "block.minecraft.crimson_nylium": "Црвен Пеколцелиум",
  "block.minecraft.crimson_planks": "Црвени Даски",
  "block.minecraft.crimson_pressure_plate": "Црвена Притисочна Плочка",
  "block.minecraft.crimson_roots": "Црвени Корени",
  "block.minecraft.crimson_shelf": "Crimson Shelf",
  "block.minecraft.crimson_sign": "Црвен Знак",
  "block.minecraft.crimson_slab": "Црвена Плочка",
  "block.minecraft.crimson_stairs": "Црвени Скали",
  "block.minecraft.crimson_stem": "Црвено Стебло",
  "block.minecraft.crimson_trapdoor": "Црвена Подна Врата",
  "block.minecraft.crimson_wall_hanging_sign": "Темноцрвен висечки знак",
  "block.minecraft.crimson_wall_sign": "Црвен Sиден Знак",
  "block.minecraft.crying_obsidian": "Плачлив Обцидиан",
  "block.minecraft.cut_copper": "Сечен бакар",
  "block.minecraft.cut_copper_slab": "Исечена бакарна плоча",
  "block.minecraft.cut_copper_stairs": "Исечени скали од бакар",
  "block.minecraft.cut_red_sandstone": "Сечен црвен песочник",
  "block.minecraft.cut_red_sandstone_slab": "Плоча од сечен црвен песочник",
  "block.minecraft.cut_sandstone": "Сечен песочник",
  "block.minecraft.cut_sandstone_slab": "Плоча од сечен песочник",
  "block.minecraft.cyan_banner": "Сино-зелен банер",
  "block.minecraft.cyan_bed": "Сино-зелен кревет",
  "block.minecraft.cyan_candle": "Тиркизна свеќа",
  "block.minecraft.cyan_candle_cake": "Торта со Трикизна Свеќа",
  "block.minecraft.cyan_carpet": "Сино-зелен тепих",
  "block.minecraft.cyan_concrete": "Сино-зелен бетон",
  "block.minecraft.cyan_concrete_powder": "Сино-зелен бетон во прав",
  "block.minecraft.cyan_glazed_terracotta": "Сино-зелена глазирана теракота",
  "block.minecraft.cyan_shulker_box": "Сино-зелена шулкер кутија",
  "block.minecraft.cyan_stained_glass": "Сино-зелено стакло",
  "block.minecraft.cyan_stained_glass_pane": "Сино-зелена стаклена рамка",
  "block.minecraft.cyan_terracotta": "Сино-зелена теракота",
  "block.minecraft.cyan_wool": "Сино-зелена волна",
  "block.minecraft.damaged_anvil": "Оштетена наковална",
  "block.minecraft.dandelion": "Глуварче",
  "block.minecraft.dark_oak_button": "Копче од темен даб",
  "block.minecraft.dark_oak_door": "Врата од темен даб",
  "block.minecraft.dark_oak_fence": "Ограда од темен даб",
  "block.minecraft.dark_oak_fence_gate": "Врата за ограда од темен даб",
  "block.minecraft.dark_oak_hanging_sign": "Висечки знак од темен даб",
  "block.minecraft.dark_oak_leaves": "Лисја од темен даб",
  "block.minecraft.dark_oak_log": "Труп од темен даб",
  "block.minecraft.dark_oak_planks": "Даски од темен даб",
  "block.minecraft.dark_oak_pressure_plate": "Притисна плоча од темен даб",
  "block.minecraft.dark_oak_sapling": "Фиданка од темен даб",
  "block.minecraft.dark_oak_shelf": "Dark Oak Shelf",
  "block.minecraft.dark_oak_sign": "Знак од темен даб",
  "block.minecraft.dark_oak_slab": "Плоча од темен даб",
  "block.minecraft.dark_oak_stairs": "Скали од темен даб",
  "block.minecraft.dark_oak_trapdoor": "Врата-стапица од темен даб",
  "block.minecraft.dark_oak_wall_hanging_sign": "Висечки знак од темен даб",
  "block.minecraft.dark_oak_wall_sign": "Ѕиден знак од темен даб",
  "block.minecraft.dark_oak_wood": "Темен даб",
  "block.minecraft.dark_prismarine": "Темен призмарин",
  "block.minecraft.dark_prismarine_slab": "Плоча од темен призмарин",
  "block.minecraft.dark_prismarine_stairs": "Скали од темен призмарин",
  "block.minecraft.daylight_detector": "Сензор за дневна светлина",
  "block.minecraft.dead_brain_coral": "Мртов мозочен корал",
  "block.minecraft.dead_brain_coral_block": "Мртов мозочен корален блок",
  "block.minecraft.dead_brain_coral_fan": "Мртва мозочна корална лепеза",
  "block.minecraft.dead_brain_coral_wall_fan": "Мртва ѕидна мозочна корална лепеза",
  "block.minecraft.dead_bubble_coral": "Мртов меурчест корал",
  "block.minecraft.dead_bubble_coral_block": "Мртов меурчест корален блок",
  "block.minecraft.dead_bubble_coral_fan": "Мртва меурчеста корална лепеза",
  "block.minecraft.dead_bubble_coral_wall_fan": "Мртва ѕидна меурчеста корална лепеза",
  "block.minecraft.dead_bush": "Мртва грмушка",
  "block.minecraft.dead_fire_coral": "Мртов огнен корал",
  "block.minecraft.dead_fire_coral_block": "Мртов огнен корален блок",
  "block.minecraft.dead_fire_coral_fan": "Мртва огнена корална лепеза",
  "block.minecraft.dead_fire_coral_wall_fan": "Мртва ѕидна огнена корална лепеза",
  "block.minecraft.dead_horn_coral": "Мртов рожен корал",
  "block.minecraft.dead_horn_coral_block": "Мртов рожен корален блок",
  "block.minecraft.dead_horn_coral_fan": "Мртва ѕидна рожна корална лепеза",
  "block.minecraft.dead_horn_coral_wall_fan": "Мртва ѕидна рожна корална лепеза",
  "block.minecraft.dead_tube_coral": "Мртов цевчест корал",
  "block.minecraft.dead_tube_coral_block": "Мртов цевчест корален блок",
  "block.minecraft.dead_tube_coral_fan": "Мртва цевчеста корална лепеза",
  "block.minecraft.dead_tube_coral_wall_fan": "Мртва ѕидна цевчеста корална лепеза",
  "block.minecraft.decorated_pot": "Украсено тенџере",
  "block.minecraft.deepslate": "Шкрилец",
  "block.minecraft.deepslate_brick_slab": "Плоча од шкрлести цигли",
  "block.minecraft.deepslate_brick_stairs": "Скали од шкрлести цигли",
  "block.minecraft.deepslate_brick_wall": "Зид од шкрилести цигли",
  "block.minecraft.deepslate_bricks": "Шкрласти цигли",
  "block.minecraft.deepslate_coal_ore": "Руда од јаглен со длабоки плочи",
  "block.minecraft.deepslate_copper_ore": "Шкрилеста руда бакар",
  "block.minecraft.deepslate_diamond_ore": "Шкрилеста дијамантска руда",
  "block.minecraft.deepslate_emerald_ore": "Шкрилеста руда смарагд",
  "block.minecraft.deepslate_gold_ore": "Шкрилеста златна руда",
  "block.minecraft.deepslate_iron_ore": "Шкрилеста железна руда",
  "block.minecraft.deepslate_lapis_ore": "Шкрилеста руда од лапис лазули",
  "block.minecraft.deepslate_redstone_ore": "Шкрилеста редстоун руда",
  "block.minecraft.deepslate_tile_slab": "Плоча од шкрилести плочки",
  "block.minecraft.deepslate_tile_stairs": "Скали од шкрилести плочки",
  "block.minecraft.deepslate_tile_wall": "Зид од шкрилести плочки",
  "block.minecraft.deepslate_tiles": "Шкрлести плочки",
  "block.minecraft.detector_rail": "Детектирачка пруга",
  "block.minecraft.diamond_block": "Блок од дијамант",
  "block.minecraft.diamond_ore": "Дијамантска руда",
  "block.minecraft.diorite": "Диорит",
  "block.minecraft.diorite_slab": "Диоритна плоча",
  "block.minecraft.diorite_stairs": "Диоритни скали",
  "block.minecraft.diorite_wall": "Диоритен ѕид",
  "block.minecraft.dirt": "Земја",
  "block.minecraft.dirt_path": "Патека од земја",
  "block.minecraft.dispenser": "Раздавач",
  "block.minecraft.dragon_egg": "Змејско јајце",
  "block.minecraft.dragon_head": "Глава од змеј",
  "block.minecraft.dragon_wall_head": "Ѕидна глава од змеј",
  "block.minecraft.dried_ghast": "Dried Ghast",
  "block.minecraft.dried_kelp_block": "Блок од исушена алга",
  "block.minecraft.dripstone_block": "Дрипстоун блок",
  "block.minecraft.dropper": "Исфрлувач",
  "block.minecraft.emerald_block": "Блок од смарагд",
  "block.minecraft.emerald_ore": "Смарагдна руда",
  "block.minecraft.enchanting_table": "Маса за маѓепсување",
  "block.minecraft.end_gateway": "Енд портал",
  "block.minecraft.end_portal": "Енд портал",
  "block.minecraft.end_portal_frame": "Рамка за Енд портал",
  "block.minecraft.end_rod": "Енд прачка",
  "block.minecraft.end_stone": "Енд камен",
  "block.minecraft.end_stone_brick_slab": "Плоча од Енд камени цигли",
  "block.minecraft.end_stone_brick_stairs": "Скали од Енд цигли",
  "block.minecraft.end_stone_brick_wall": "Ѕид од Енд камени цигли",
  "block.minecraft.end_stone_bricks": "Цигли од енд камен",
  "block.minecraft.ender_chest": "Ендер сандак",
  "block.minecraft.exposed_chiseled_copper": "Exposed Chiseled Copper",
  "block.minecraft.exposed_copper": "Изложен бакар",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Exposed Copper Bulb",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "Exposed Copper Door",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "Exposed Copper Grate",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Exposed Copper Trapdoor",
  "block.minecraft.exposed_cut_copper": "Изложен исечен бакар",
  "block.minecraft.exposed_cut_copper_slab": "Изложена исечена бакарна плоча",
  "block.minecraft.exposed_cut_copper_stairs": "Изложени исечени бакарни скали",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "Обработлива земја",
  "block.minecraft.fern": "Папрат",
  "block.minecraft.fire": "Оган",
  "block.minecraft.fire_coral": "Огнен корал",
  "block.minecraft.fire_coral_block": "Огнен корален блок",
  "block.minecraft.fire_coral_fan": "Огнена корална лепеза",
  "block.minecraft.fire_coral_wall_fan": "Ѕидна огнена корална лепеза",
  "block.minecraft.firefly_bush": "Firefly Bush",
  "block.minecraft.fletching_table": "Маса за изработка на стрели",
  "block.minecraft.flower_pot": "Саксија",
  "block.minecraft.flowering_azalea": "Цветни Azalea",
  "block.minecraft.flowering_azalea_leaves": "Цветни лисја од Азалеа",
  "block.minecraft.frogspawn": "Жаба мрест",
  "block.minecraft.frosted_ice": "Замрзнат лед",
  "block.minecraft.furnace": "Печка",
  "block.minecraft.gilded_blackstone": "Златен Црн Камен",
  "block.minecraft.glass": "Стакло",
  "block.minecraft.glass_pane": "Стаклена рамка",
  "block.minecraft.glow_lichen": "Сјај лишаи",
  "block.minecraft.glowstone": "Светлосен камен",
  "block.minecraft.gold_block": "Блок од злато",
  "block.minecraft.gold_ore": "Златна руда",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Гранит",
  "block.minecraft.granite_slab": "Гранитна плоча",
  "block.minecraft.granite_stairs": "Гранитни скали",
  "block.minecraft.granite_wall": "Гранитен ѕид",
  "block.minecraft.grass": "Трева",
  "block.minecraft.grass_block": "Блок од трева",
  "block.minecraft.gravel": "Чакал",
  "block.minecraft.gray_banner": "Сив банер",
  "block.minecraft.gray_bed": "Сив кревет",
  "block.minecraft.gray_candle": "Сива свеќа",
  "block.minecraft.gray_candle_cake": "Торта со Сива Свеќа",
  "block.minecraft.gray_carpet": "Сив тепих",
  "block.minecraft.gray_concrete": "Сив бетон",
  "block.minecraft.gray_concrete_powder": "Сив бетон во прав",
  "block.minecraft.gray_glazed_terracotta": "Сива глазирана теракота",
  "block.minecraft.gray_shulker_box": "Сива шулкер кутија",
  "block.minecraft.gray_stained_glass": "Сиво стакло",
  "block.minecraft.gray_stained_glass_pane": "Сива стаклена рамка",
  "block.minecraft.gray_terracotta": "Сива теракота",
  "block.minecraft.gray_wool": "Сива волна",
  "block.minecraft.green_banner": "Зелен банер",
  "block.minecraft.green_bed": "Зелен кревет",
  "block.minecraft.green_candle": "Зелена свеќа",
  "block.minecraft.green_candle_cake": "Торта со Зелена Свеќа",
  "block.minecraft.green_carpet": "Зелен тепих",
  "block.minecraft.green_concrete": "Зелен бетон",
  "block.minecraft.green_concrete_powder": "Зелен бетон во прав",
  "block.minecraft.green_glazed_terracotta": "Зелена глазирана теракота",
  "block.minecraft.green_shulker_box": "Зелена шулкер кутија",
  "block.minecraft.green_stained_glass": "Зелено стакло",
  "block.minecraft.green_stained_glass_pane": "Зелена стаклена рамка",
  "block.minecraft.green_terracotta": "Зелена теракота",
  "block.minecraft.green_wool": "Зелена волна",
  "block.minecraft.grindstone": "Камен за острење",
  "block.minecraft.hanging_roots": "Висни корени",
  "block.minecraft.hay_block": "Бала сено",
  "block.minecraft.heavy_core": "Heavy Core",
  "block.minecraft.heavy_weighted_pressure_plate": "Тешкотежинска притисна плоча",
  "block.minecraft.honey_block": "Меден блок",
  "block.minecraft.honeycomb_block": "Саќена Коцка",
  "block.minecraft.hopper": "Собирач",
  "block.minecraft.horn_coral": "Рожен корал",
  "block.minecraft.horn_coral_block": "Рожен корален блок",
  "block.minecraft.horn_coral_fan": "Рожна корална лепеза",
  "block.minecraft.horn_coral_wall_fan": "Ѕидна рожна корална лепеза",
  "block.minecraft.ice": "Мраз",
  "block.minecraft.infested_chiseled_stone_bricks": "Заразени длетувани камени цигли",
  "block.minecraft.infested_cobblestone": "Заразена калдрма",
  "block.minecraft.infested_cracked_stone_bricks": "Заразени напукнати камени цигли",
  "block.minecraft.infested_deepslate": "Заразен шкрилец",
  "block.minecraft.infested_mossy_stone_bricks": "Заразени мовливи камени цигли",
  "block.minecraft.infested_stone": "Заразен камен",
  "block.minecraft.infested_stone_bricks": "Заразени камени цигли",
  "block.minecraft.iron_bars": "Железни решетки",
  "block.minecraft.iron_block": "Блок од железо",
  "block.minecraft.iron_chain": "Iron Chain",
  "block.minecraft.iron_door": "Железна врата",
  "block.minecraft.iron_ore": "Железна руда",
  "block.minecraft.iron_trapdoor": "Железна врата-стапица",
  "block.minecraft.jack_o_lantern": "Тиквен фенер",
  "block.minecraft.jigsaw": "Сложувалка",
  "block.minecraft.jukebox": "Џубокс",
  "block.minecraft.jungle_button": "Копче од џунглиско дрво",
  "block.minecraft.jungle_door": "Врата од џунглиско дрво",
  "block.minecraft.jungle_fence": "Ограда од џунглиско дрво",
  "block.minecraft.jungle_fence_gate": "Врата за ограда од џунглиско дрво",
  "block.minecraft.jungle_hanging_sign": "Јунглев висечки знак",
  "block.minecraft.jungle_leaves": "Лисја од џунглиско дрво",
  "block.minecraft.jungle_log": "Труп од џунглиско дрво",
  "block.minecraft.jungle_planks": "Даски од џунглиско дрво",
  "block.minecraft.jungle_pressure_plate": "Притисна плоча од џунглиско дрво",
  "block.minecraft.jungle_sapling": "Фиданка од џунглиско дрво",
  "block.minecraft.jungle_shelf": "Jungle Shelf",
  "block.minecraft.jungle_sign": "Знак од џунглиско дрво",
  "block.minecraft.jungle_slab": "Плоча од џунглиско дрво",
  "block.minecraft.jungle_stairs": "Скали од џунглиско дрво",
  "block.minecraft.jungle_trapdoor": "Врата-стапица од џунглиско дрво",
  "block.minecraft.jungle_wall_hanging_sign": "Јунглев визечки знак",
  "block.minecraft.jungle_wall_sign": "Ѕиден знак од џунглиско дрво",
  "block.minecraft.jungle_wood": "Џунглиско Дрво",
  "block.minecraft.kelp": "Алга",
  "block.minecraft.kelp_plant": "Алга растение",
  "block.minecraft.ladder": "Скала",
  "block.minecraft.lantern": "Фенер",
  "block.minecraft.lapis_block": "Блок од Лапис Лазули",
  "block.minecraft.lapis_ore": "Лазурна руда",
  "block.minecraft.large_amethyst_bud": "Големи пупки од аметист",
  "block.minecraft.large_fern": "Голем папрат",
  "block.minecraft.lava": "Лава",
  "block.minecraft.lava_cauldron": "Казан со лава",
  "block.minecraft.leaf_litter": "Leaf Litter",
  "block.minecraft.lectern": "Наслон за читање",
  "block.minecraft.lever": "Рачка",
  "block.minecraft.light": "Светлина",
  "block.minecraft.light_blue_banner": "Светлосин банер",
  "block.minecraft.light_blue_bed": "Светлосин кревет",
  "block.minecraft.light_blue_candle": "Светло сина свеќа",
  "block.minecraft.light_blue_candle_cake": "Торта со Светло Сина Свеќа",
  "block.minecraft.light_blue_carpet": "Светлосин тепих",
  "block.minecraft.light_blue_concrete": "Светлосин бетон",
  "block.minecraft.light_blue_concrete_powder": "Светлосин бетон во прав",
  "block.minecraft.light_blue_glazed_terracotta": "Светлосина глазирана теракота",
  "block.minecraft.light_blue_shulker_box": "Светлосина шулкер кутија",
  "block.minecraft.light_blue_stained_glass": "Светлосино стакло",
  "block.minecraft.light_blue_stained_glass_pane": "Светлосина стаклена рамка",
  "block.minecraft.light_blue_terracotta": "Светлосина теракота",
  "block.minecraft.light_blue_wool": "Светлосина волна",
  "block.minecraft.light_gray_banner": "Светлосив банер",
  "block.minecraft.light_gray_bed": "Светлосив кревет",
  "block.minecraft.light_gray_candle": "Светло сива свеќа",
  "block.minecraft.light_gray_candle_cake": "Торта со Светло Сива Свеќа",
  "block.minecraft.light_gray_carpet": "Светлосив тепих",
  "block.minecraft.light_gray_concrete": "Светлосив бетон",
  "block.minecraft.light_gray_concrete_powder": "Светлосив бетон во прав",
  "block.minecraft.light_gray_glazed_terracotta": "Светлосина глазирана теракота",
  "block.minecraft.light_gray_shulker_box": "Светлосива шулкер кутија",
  "block.minecraft.light_gray_stained_glass": "Светлосиво стакло",
  "block.minecraft.light_gray_stained_glass_pane": "Светлосива стаклена рамка",
  "block.minecraft.light_gray_terracotta": "Светлосива теракота",
  "block.minecraft.light_gray_wool": "Светлосива волна",
  "block.minecraft.light_weighted_pressure_plate": "Леснотежинска притисна плоча",
  "block.minecraft.lightning_rod": "Громобран",
  "block.minecraft.lilac": "Јоргован",
  "block.minecraft.lily_of_the_valley": "Момина солза",
  "block.minecraft.lily_pad": "Воден лилјан",
  "block.minecraft.lime_banner": "Жолто-зелен банер",
  "block.minecraft.lime_bed": "Жолто-зелен кревет",
  "block.minecraft.lime_candle": "Светло зелена свеќа",
  "block.minecraft.lime_candle_cake": "Торта со Светло Зелена Свеќа",
  "block.minecraft.lime_carpet": "Жолто-зелен тепих",
  "block.minecraft.lime_concrete": "Жолто-зелен бетон",
  "block.minecraft.lime_concrete_powder": "Жолто-зелен бетон во прав",
  "block.minecraft.lime_glazed_terracotta": "Жолто-зелена глазирана теракота",
  "block.minecraft.lime_shulker_box": "Жолто-зелена шулкер кутија",
  "block.minecraft.lime_stained_glass": "Жолто-зелено стакло",
  "block.minecraft.lime_stained_glass_pane": "Жолто-зелена стаклена рамка",
  "block.minecraft.lime_terracotta": "Жолто-зелена теракота",
  "block.minecraft.lime_wool": "Жолто-зелена волна",
  "block.minecraft.lodestone": "Магнетен Камен",
  "block.minecraft.loom": "Разбој",
  "block.minecraft.magenta_banner": "Магента банер",
  "block.minecraft.magenta_bed": "Магента кревет",
  "block.minecraft.magenta_candle": "Магента свеќа",
  "block.minecraft.magenta_candle_cake": "Торта со Магента Свеќа",
  "block.minecraft.magenta_carpet": "Магента тепих",
  "block.minecraft.magenta_concrete": "Магента бетон",
  "block.minecraft.magenta_concrete_powder": "Магента бетон во прав",
  "block.minecraft.magenta_glazed_terracotta": "Магента глазирана теракота",
  "block.minecraft.magenta_shulker_box": "Магента шулкер кутија",
  "block.minecraft.magenta_stained_glass": "Магента стакло",
  "block.minecraft.magenta_stained_glass_pane": "Магента стаклена рамка",
  "block.minecraft.magenta_terracotta": "Магента теракота",
  "block.minecraft.magenta_wool": "Магента волна",
  "block.minecraft.magma_block": "Блок од магма",
  "block.minecraft.mangrove_button": "Копче до мангрово дрво",
  "block.minecraft.mangrove_door": "Врата од мангрова",
  "block.minecraft.mangrove_fence": "Мангрова ограда",
  "block.minecraft.mangrove_fence_gate": "Мангрова порта",
  "block.minecraft.mangrove_hanging_sign": "Мангров висечки знак",
  "block.minecraft.mangrove_leaves": "Лисја од мангрова",
  "block.minecraft.mangrove_log": "Труп од мангрова",
  "block.minecraft.mangrove_planks": "Штици од мангрови",
  "block.minecraft.mangrove_pressure_plate": "Плоча за притисок од мангрово дрво",
  "block.minecraft.mangrove_propagule": "Мангрова пропагул",
  "block.minecraft.mangrove_roots": "Корени од мангрова",
  "block.minecraft.mangrove_shelf": "Mangrove Shelf",
  "block.minecraft.mangrove_sign": "Знак од мангрово дрво",
  "block.minecraft.mangrove_slab": "Плоча од мангрови штици",
  "block.minecraft.mangrove_stairs": "Скали од мангрова штица",
  "block.minecraft.mangrove_trapdoor": "Мангрова Trapdoor",
  "block.minecraft.mangrove_wall_hanging_sign": "Висечки знак на зид од мангров",
  "block.minecraft.mangrove_wall_sign": "Ѕиден знак од мангрово дрво",
  "block.minecraft.mangrove_wood": "Мангрово Дрво",
  "block.minecraft.medium_amethyst_bud": "Средна пупка од аметист",
  "block.minecraft.melon": "Лубеница",
  "block.minecraft.melon_stem": "Стебло од лубеница",
  "block.minecraft.moss_block": "Мов блок",
  "block.minecraft.moss_carpet": "Мов тепих",
  "block.minecraft.mossy_cobblestone": "Мовлива калдрма",
  "block.minecraft.mossy_cobblestone_slab": "Плоча од мовлива калдрма",
  "block.minecraft.mossy_cobblestone_stairs": "Скали од мовлива калдрма",
  "block.minecraft.mossy_cobblestone_wall": "Ѕид од мовлива калдрма",
  "block.minecraft.mossy_stone_brick_slab": "Плоча од мовливи камени цигли",
  "block.minecraft.mossy_stone_brick_stairs": "Скали од мовливи камени цигли",
  "block.minecraft.mossy_stone_brick_wall": "Ѕид од мовливи камени цигли",
  "block.minecraft.mossy_stone_bricks": "Мовливи камени цигли",
  "block.minecraft.moving_piston": "Подвижен клип",
  "block.minecraft.mud": "Кал",
  "block.minecraft.mud_brick_slab": "Плоча од кал тули",
  "block.minecraft.mud_brick_stairs": "Скали од кал од тули",
  "block.minecraft.mud_brick_wall": "Ѕид од кал од тули",
  "block.minecraft.mud_bricks": "Цигли од кал",
  "block.minecraft.muddy_mangrove_roots": "Калливи корени од мангрова",
  "block.minecraft.mushroom_stem": "Стебло од печурка",
  "block.minecraft.mycelium": "Мицелиум",
  "block.minecraft.nether_brick_fence": "Ограда од Недер цигли",
  "block.minecraft.nether_brick_slab": "Плоча од Недер цигли",
  "block.minecraft.nether_brick_stairs": "Скали од Недер цигли",
  "block.minecraft.nether_brick_wall": "Ѕид од Недер цигли",
  "block.minecraft.nether_bricks": "Недер цигли",
  "block.minecraft.nether_gold_ore": "Пеколна Златна Руда",
  "block.minecraft.nether_portal": "Недер портал",
  "block.minecraft.nether_quartz_ore": "Недер-кварцна руда",
  "block.minecraft.nether_sprouts": "Пеколски Клици",
  "block.minecraft.nether_wart": "Недер лишај",
  "block.minecraft.nether_wart_block": "Блок од Недер растение",
  "block.minecraft.netherite_block": "Коцка од Пеколит",
  "block.minecraft.netherrack": "Недер камен",
  "block.minecraft.note_block": "Музички блок",
  "block.minecraft.oak_button": "Копче од даб",
  "block.minecraft.oak_door": "Врата од даб",
  "block.minecraft.oak_fence": "Ограда од даб",
  "block.minecraft.oak_fence_gate": "Врата за ограда од даб",
  "block.minecraft.oak_hanging_sign": "Дабов бисечки знак",
  "block.minecraft.oak_leaves": "Лисја од даб",
  "block.minecraft.oak_log": "Труп од даб",
  "block.minecraft.oak_planks": "Даски од даб",
  "block.minecraft.oak_pressure_plate": "Притисна плоча од даб",
  "block.minecraft.oak_sapling": "Фиданка од даб",
  "block.minecraft.oak_shelf": "Oak Shelf",
  "block.minecraft.oak_sign": "Знак од даб",
  "block.minecraft.oak_slab": "Плоча од даб",
  "block.minecraft.oak_stairs": "Скали од даб",
  "block.minecraft.oak_trapdoor": "Врата-стапица од даб",
  "block.minecraft.oak_wall_hanging_sign": "Дабов зид висечки знак",
  "block.minecraft.oak_wall_sign": "Ѕиден знак од даб",
  "block.minecraft.oak_wood": "Даб",
  "block.minecraft.observer": "Опсерватор",
  "block.minecraft.obsidian": "Обсидијан",
  "block.minecraft.ochre_froglight": "Окер жаби",
  "block.minecraft.ominous_banner": "Застрашувачки банер",
  "block.minecraft.open_eyeblossom": "Open Eyeblossom",
  "block.minecraft.orange_banner": "Портокалов банер",
  "block.minecraft.orange_bed": "Портокалов кревет",
  "block.minecraft.orange_candle": "Портокалова свеќа",
  "block.minecraft.orange_candle_cake": "Торта со Портокалова Свеќа",
  "block.minecraft.orange_carpet": "Портокалов тепих",
  "block.minecraft.orange_concrete": "Портокалов бетон",
  "block.minecraft.orange_concrete_powder": "Портокалов бетон во прав",
  "block.minecraft.orange_glazed_terracotta": "Портокалова глазирана теракота",
  "block.minecraft.orange_shulker_box": "Портокалова шулкер кутија",
  "block.minecraft.orange_stained_glass": "Портокалово стакло",
  "block.minecraft.orange_stained_glass_pane": "Портокалова стаклена рамка",
  "block.minecraft.orange_terracotta": "Портокалова теракота",
  "block.minecraft.orange_tulip": "Портокалово лале",
  "block.minecraft.orange_wool": "Портокалова волна",
  "block.minecraft.oxeye_daisy": "Маргаритка",
  "block.minecraft.oxidized_chiseled_copper": "Oxidized Chiseled Copper",
  "block.minecraft.oxidized_copper": "Оксидиран бакар",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Oxidized Copper Bulb",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "Oxidized Copper Door",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Oxidized Copper Grate",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Oxidized Copper Trapdoor",
  "block.minecraft.oxidized_cut_copper": "Оксидиран бакар за сечење",
  "block.minecraft.oxidized_cut_copper_slab": "Оксидирана плоча од бакар",
  "block.minecraft.oxidized_cut_copper_stairs": "Оксидирани скали од бакар",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "Тврд лед",
  "block.minecraft.packed_mud": "Набиена кал",
  "block.minecraft.pale_hanging_moss": "Pale Hanging Moss",
  "block.minecraft.pale_moss_block": "Pale Moss Block",
  "block.minecraft.pale_moss_carpet": "Pale Moss Carpet",
  "block.minecraft.pale_oak_button": "Pale Oak Button",
  "block.minecraft.pale_oak_door": "Pale Oak Door",
  "block.minecraft.pale_oak_fence": "Pale Oak Fence",
  "block.minecraft.pale_oak_fence_gate": "Pale Oak Fence Gate",
  "block.minecraft.pale_oak_hanging_sign": "Pale Oak Hanging Sign",
  "block.minecraft.pale_oak_leaves": "Pale Oak Leaves",
  "block.minecraft.pale_oak_log": "Pale Oak Log",
  "block.minecraft.pale_oak_planks": "Pale Oak Planks",
  "block.minecraft.pale_oak_pressure_plate": "Pale Oak Pressure Plate",
  "block.minecraft.pale_oak_sapling": "Pale Oak Sapling",
  "block.minecraft.pale_oak_shelf": "Pale Oak Shelf",
  "block.minecraft.pale_oak_sign": "Pale Oak Sign",
  "block.minecraft.pale_oak_slab": "Pale Oak Slab",
  "block.minecraft.pale_oak_stairs": "Pale Oak Stairs",
  "block.minecraft.pale_oak_trapdoor": "Pale Oak Trapdoor",
  "block.minecraft.pale_oak_wall_hanging_sign": "Pale Oak Wall Hanging Sign",
  "block.minecraft.pale_oak_wall_sign": "Pale Oak Wall Sign",
  "block.minecraft.pale_oak_wood": "Pale Oak Wood",
  "block.minecraft.pearlescent_froglight": "Бисерна жабичка",
  "block.minecraft.peony": "Божур",
  "block.minecraft.petrified_oak_slab": "Скаменета плоча од даб",
  "block.minecraft.piglin_head": "Раководител на Пиглин",
  "block.minecraft.piglin_wall_head": "Глава на ѕидот на пиглин",
  "block.minecraft.pink_banner": "Розов банер",
  "block.minecraft.pink_bed": "Розов кревет",
  "block.minecraft.pink_candle": "Розева свеќа",
  "block.minecraft.pink_candle_cake": "Торта со Розева Свеќа",
  "block.minecraft.pink_carpet": "Розов тепих",
  "block.minecraft.pink_concrete": "Розов бетон",
  "block.minecraft.pink_concrete_powder": "Розов бетон во прав",
  "block.minecraft.pink_glazed_terracotta": "Розова глазирана теракота",
  "block.minecraft.pink_petals": "Розеви ливчиња",
  "block.minecraft.pink_shulker_box": "Розова шулкер кутија",
  "block.minecraft.pink_stained_glass": "Розово стакло",
  "block.minecraft.pink_stained_glass_pane": "Розова стаклена рамка",
  "block.minecraft.pink_terracotta": "Розова теракота",
  "block.minecraft.pink_tulip": "Розово лале",
  "block.minecraft.pink_wool": "Розова волна",
  "block.minecraft.piston": "Клип",
  "block.minecraft.piston_head": "Клипна глава",
  "block.minecraft.pitcher_crop": "Стомна култура",
  "block.minecraft.pitcher_plant": "Pitcher Plant",
  "block.minecraft.player_head": "Глава од играч",
  "block.minecraft.player_head.named": "Главата на %s",
  "block.minecraft.player_wall_head": "Ѕидна глава од играч",
  "block.minecraft.podzol": "Подзол",
  "block.minecraft.pointed_dripstone": "Посочен Дрипстоун",
  "block.minecraft.polished_andesite": "Полиран андезит",
  "block.minecraft.polished_andesite_slab": "Полирана андезитна плоча",
  "block.minecraft.polished_andesite_stairs": "Полирани андезитни скали",
  "block.minecraft.polished_basalt": "Измазен Базалт",
  "block.minecraft.polished_blackstone": "Размазен Црн Камен",
  "block.minecraft.polished_blackstone_brick_slab": "Плочка од Размазени Цигли од Црн Камен",
  "block.minecraft.polished_blackstone_brick_stairs": "Скали од Размазени Цигли од Црн Камен",
  "block.minecraft.polished_blackstone_brick_wall": "Sид од Размазен Црн Камен",
  "block.minecraft.polished_blackstone_bricks": "Размазени Цигли од Црн Камен",
  "block.minecraft.polished_blackstone_button": "Размазено Копче од Црн Камен",
  "block.minecraft.polished_blackstone_pressure_plate": "Размазена Притисочна Плочка од Црн Камен",
  "block.minecraft.polished_blackstone_slab": "Плочка од Размазен Црн Камен",
  "block.minecraft.polished_blackstone_stairs": "Скали од Размазен Црн Камен",
  "block.minecraft.polished_blackstone_wall": "Sид од Размазен Црн Камен",
  "block.minecraft.polished_deepslate": "Полиран шкрилец",
  "block.minecraft.polished_deepslate_slab": "Полиран калдрмаст шкрилец",
  "block.minecraft.polished_deepslate_stairs": "Скали полирани со шкрилец",
  "block.minecraft.polished_deepslate_wall": "Зид полиран со шкрилец",
  "block.minecraft.polished_diorite": "Полиран диорит",
  "block.minecraft.polished_diorite_slab": "Полирана диоритна плоча",
  "block.minecraft.polished_diorite_stairs": "Скали од полиран диорит",
  "block.minecraft.polished_granite": "Полиран гранит",
  "block.minecraft.polished_granite_slab": "Полирана гранитна плоча",
  "block.minecraft.polished_granite_stairs": "Полирани гранитни скали",
  "block.minecraft.polished_tuff": "Polished Tuff",
  "block.minecraft.polished_tuff_slab": "Polished Tuff Slab",
  "block.minecraft.polished_tuff_stairs": "Polished Tuff Stairs",
  "block.minecraft.polished_tuff_wall": "Polished Tuff Wall",
  "block.minecraft.poppy": "Афион",
  "block.minecraft.potatoes": "Компири",
  "block.minecraft.potted_acacia_sapling": "Саксија со фиданка од акација",
  "block.minecraft.potted_allium": "Саксија со алиум",
  "block.minecraft.potted_azalea_bush": "Кондензирана азалеа",
  "block.minecraft.potted_azure_bluet": "Саксија со лазурен блует",
  "block.minecraft.potted_bamboo": "Саксија со бамбус",
  "block.minecraft.potted_birch_sapling": "Саксија со фиданка од бреза",
  "block.minecraft.potted_blue_orchid": "Саксија со сина орхидеја",
  "block.minecraft.potted_brown_mushroom": "Саксија со кафеава печурка",
  "block.minecraft.potted_cactus": "Саксија со кактус",
  "block.minecraft.potted_cherry_sapling": "Potted Cherry Sapling",
  "block.minecraft.potted_closed_eyeblossom": "Potted Closed Eyeblossom",
  "block.minecraft.potted_cornflower": "Саксија со модрика",
  "block.minecraft.potted_crimson_fungus": "Црвена Печурка во Саксија",
  "block.minecraft.potted_crimson_roots": "Црвени Корени во Саксија",
  "block.minecraft.potted_dandelion": "Саксија со глуварче",
  "block.minecraft.potted_dark_oak_sapling": "Саксија со фиданка од темен даб",
  "block.minecraft.potted_dead_bush": "Саксија со мртва грмушка",
  "block.minecraft.potted_fern": "Саксија со папрат",
  "block.minecraft.potted_flowering_azalea_bush": "Кондензирана цветна азалеа",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Саксија со фиданка од џунглиско дрво",
  "block.minecraft.potted_lily_of_the_valley": "Саксија со момина солза",
  "block.minecraft.potted_mangrove_propagule": "Кондензиран мангрова пропагул",
  "block.minecraft.potted_oak_sapling": "Саксија со фиданка од даб",
  "block.minecraft.potted_open_eyeblossom": "Potted Open Eyeblossom",
  "block.minecraft.potted_orange_tulip": "Саксија со портокалово лале",
  "block.minecraft.potted_oxeye_daisy": "Саксија со маргаритка",
  "block.minecraft.potted_pale_oak_sapling": "Potted Pale Oak Sapling",
  "block.minecraft.potted_pink_tulip": "Саксија со розово лале",
  "block.minecraft.potted_poppy": "Саксија со афион",
  "block.minecraft.potted_red_mushroom": "Саксија со црвена печурка",
  "block.minecraft.potted_red_tulip": "Саксија со црвено лале",
  "block.minecraft.potted_spruce_sapling": "Саксија со фиданка од смрека",
  "block.minecraft.potted_torchflower": "Potted Torchflower",
  "block.minecraft.potted_warped_fungus": "Луда Печурка во Саксија",
  "block.minecraft.potted_warped_roots": "Луди Корени во Саксија",
  "block.minecraft.potted_white_tulip": "Саксија со бело лале",
  "block.minecraft.potted_wither_rose": "Саксија со видер роза",
  "block.minecraft.powder_snow": "Снег во прав",
  "block.minecraft.powder_snow_cauldron": "Казан со снег",
  "block.minecraft.powered_rail": "Погонска пруга",
  "block.minecraft.prismarine": "Призмарин",
  "block.minecraft.prismarine_brick_slab": "Плоча од призмарински цигли",
  "block.minecraft.prismarine_brick_stairs": "Скали од призмарински цигли",
  "block.minecraft.prismarine_bricks": "Призмарински цигли",
  "block.minecraft.prismarine_slab": "Плоча од призмарин",
  "block.minecraft.prismarine_stairs": "Скали од призмарин",
  "block.minecraft.prismarine_wall": "Ѕид од призмарин",
  "block.minecraft.pumpkin": "Тиква",
  "block.minecraft.pumpkin_stem": "Стебло од тиква",
  "block.minecraft.purple_banner": "Виолетов банер",
  "block.minecraft.purple_bed": "Виолетов кревет",
  "block.minecraft.purple_candle": "Виолетова свеќа",
  "block.minecraft.purple_candle_cake": "Торта со Виолетова Свеќа",
  "block.minecraft.purple_carpet": "Виолетов тепих",
  "block.minecraft.purple_concrete": "Виолетов бетон",
  "block.minecraft.purple_concrete_powder": "Виолетов бетон во прав",
  "block.minecraft.purple_glazed_terracotta": "Виолетова глазирана теракота",
  "block.minecraft.purple_shulker_box": "Виолетова шулкер кутија",
  "block.minecraft.purple_stained_glass": "Виолетово стакло",
  "block.minecraft.purple_stained_glass_pane": "Виолетова стаклена рамка",
  "block.minecraft.purple_terracotta": "Виолетова теракота",
  "block.minecraft.purple_wool": "Виолетова волна",
  "block.minecraft.purpur_block": "Блок од пурпур",
  "block.minecraft.purpur_pillar": "Столб од пурпур",
  "block.minecraft.purpur_slab": "Плоча од пурпур",
  "block.minecraft.purpur_stairs": "Скали од пурпур",
  "block.minecraft.quartz_block": "Коцка од кварц",
  "block.minecraft.quartz_bricks": "Цигли од Квартц",
  "block.minecraft.quartz_pillar": "Кварцен столб",
  "block.minecraft.quartz_slab": "Кварцна плоча",
  "block.minecraft.quartz_stairs": "Скали од кварц",
  "block.minecraft.rail": "Пруга",
  "block.minecraft.raw_copper_block": "Коцка од суров бакар",
  "block.minecraft.raw_gold_block": "Блок на сурово злато",
  "block.minecraft.raw_iron_block": "Коцка од сурово железо",
  "block.minecraft.red_banner": "Црвен банер",
  "block.minecraft.red_bed": "Црвен кревет",
  "block.minecraft.red_candle": "Црвена свеќа",
  "block.minecraft.red_candle_cake": "Торта со Црвена Свеќа",
  "block.minecraft.red_carpet": "Црвен тепих",
  "block.minecraft.red_concrete": "Црвен бетон",
  "block.minecraft.red_concrete_powder": "Црвен бетон во прав",
  "block.minecraft.red_glazed_terracotta": "Црвена глазирана теракота",
  "block.minecraft.red_mushroom": "Црвена печурка",
  "block.minecraft.red_mushroom_block": "Блок од црвена печурка",
  "block.minecraft.red_nether_brick_slab": "Плоча од црвени Недер цигли",
  "block.minecraft.red_nether_brick_stairs": "Скали од црвени Недер цигли",
  "block.minecraft.red_nether_brick_wall": "Ѕид од црвени Недер цигли",
  "block.minecraft.red_nether_bricks": "Црвени Недер цигли",
  "block.minecraft.red_sand": "Црвен песок",
  "block.minecraft.red_sandstone": "Црвен песочник",
  "block.minecraft.red_sandstone_slab": "Плоча од црвен песочник",
  "block.minecraft.red_sandstone_stairs": "Скали од црвен песочник",
  "block.minecraft.red_sandstone_wall": "Ѕид од црвен песочник",
  "block.minecraft.red_shulker_box": "Црвена шулкер кутија",
  "block.minecraft.red_stained_glass": "Црвено стакло",
  "block.minecraft.red_stained_glass_pane": "Црвена стаклена рамка",
  "block.minecraft.red_terracotta": "Црвена теракота",
  "block.minecraft.red_tulip": "Црвено лале",
  "block.minecraft.red_wool": "Црвена волна",
  "block.minecraft.redstone_block": "Блок од редстоун",
  "block.minecraft.redstone_lamp": "Ламба",
  "block.minecraft.redstone_ore": "Редстоун руда",
  "block.minecraft.redstone_torch": "Редстоун факел",
  "block.minecraft.redstone_wall_torch": "Ѕиден факел од редстоун",
  "block.minecraft.redstone_wire": "Редстоун жица",
  "block.minecraft.reinforced_deepslate": "Засилен Deepslate",
  "block.minecraft.repeater": "Редстоун повторувач",
  "block.minecraft.repeating_command_block": "Повторувачки команден блок",
  "block.minecraft.resin_block": "Block of Resin",
  "block.minecraft.resin_brick_slab": "Resin Brick Slab",
  "block.minecraft.resin_brick_stairs": "Resin Brick Stairs",
  "block.minecraft.resin_brick_wall": "Resin Brick Wall",
  "block.minecraft.resin_bricks": "Resin Bricks",
  "block.minecraft.resin_clump": "Resin Clump",
  "block.minecraft.respawn_anchor": "Преродно Сидро",
  "block.minecraft.rooted_dirt": "Вкоренета кал",
  "block.minecraft.rose_bush": "Грмушка со рози",
  "block.minecraft.sand": "Песок",
  "block.minecraft.sandstone": "Песочник",
  "block.minecraft.sandstone_slab": "Плоча од песочник",
  "block.minecraft.sandstone_stairs": "Скали од песочник",
  "block.minecraft.sandstone_wall": "Ѕид од песочник",
  "block.minecraft.scaffolding": "Скеле",
  "block.minecraft.sculk": "Скалк",
  "block.minecraft.sculk_catalyst": "Sculk катализатор",
  "block.minecraft.sculk_sensor": "Сенкул сензор",
  "block.minecraft.sculk_shrieker": "Скулк Шрикер",
  "block.minecraft.sculk_vein": "Скулк вена",
  "block.minecraft.sea_lantern": "Морски фенер",
  "block.minecraft.sea_pickle": "Морска краставица",
  "block.minecraft.seagrass": "Морска трева",
  "block.minecraft.set_spawn": "Постави точка на оживување",
  "block.minecraft.short_dry_grass": "Short Dry Grass",
  "block.minecraft.short_grass": "Кратка трева",
  "block.minecraft.shroomlight": "Печурко Светло",
  "block.minecraft.shulker_box": "Шулкер кутија",
  "block.minecraft.skeleton_skull": "Череп од скелет",
  "block.minecraft.skeleton_wall_skull": "Ѕиден череп од скелет",
  "block.minecraft.slime_block": "Коцка од слуз",
  "block.minecraft.small_amethyst_bud": "Мали пупки од аметист",
  "block.minecraft.small_dripleaf": "Мал Каплист",
  "block.minecraft.smithing_table": "Маса за ковање",
  "block.minecraft.smoker": "Пушач",
  "block.minecraft.smooth_basalt": "Мазен базалт",
  "block.minecraft.smooth_quartz": "Мазна Квартц Коцка",
  "block.minecraft.smooth_quartz_slab": "Плоча од мазен кварц",
  "block.minecraft.smooth_quartz_stairs": "Скали од мазен кварц",
  "block.minecraft.smooth_red_sandstone": "Мазен црвен песочник",
  "block.minecraft.smooth_red_sandstone_slab": "Плоча од полиран црвен песочник",
  "block.minecraft.smooth_red_sandstone_stairs": "Мазни скали од црвен песочник",
  "block.minecraft.smooth_sandstone": "Мазен песочник",
  "block.minecraft.smooth_sandstone_slab": "Плоча од мазен песочник",
  "block.minecraft.smooth_sandstone_stairs": "Скали од мазен песочник",
  "block.minecraft.smooth_stone": "Мазен камен",
  "block.minecraft.smooth_stone_slab": "Мазна камена плоча",
  "block.minecraft.sniffer_egg": "Јајце на шмркач",
  "block.minecraft.snow": "Снег",
  "block.minecraft.snow_block": "Снежен блок",
  "block.minecraft.soul_campfire": "Душни Логорски Огин",
  "block.minecraft.soul_fire": "Душни Огин",
  "block.minecraft.soul_lantern": "Душни Фенер",
  "block.minecraft.soul_sand": "Духовен песок",
  "block.minecraft.soul_soil": "Душна Земја",
  "block.minecraft.soul_torch": "Душен Факел",
  "block.minecraft.soul_wall_torch": "Душни Sиден Факел",
  "block.minecraft.spawn.not_valid": "Немаш свој домашен кревет или наполнето Преродно Сидро, или е уништено",
  "block.minecraft.spawner": "Создавач на монструми",
  "block.minecraft.spawner.desc1": "Interact with Spawn Egg:",
  "block.minecraft.spawner.desc2": "Сетови Тип на мобилна телефонија",
  "block.minecraft.sponge": "Сунѓер",
  "block.minecraft.spore_blossom": "Цвет на спори",
  "block.minecraft.spruce_button": "Копче од смрека",
  "block.minecraft.spruce_door": "Врата од смрека",
  "block.minecraft.spruce_fence": "Ограда од смрека",
  "block.minecraft.spruce_fence_gate": "Врата за ограда од смрека",
  "block.minecraft.spruce_hanging_sign": "Смрека висечки знак",
  "block.minecraft.spruce_leaves": "Лисја од смрека",
  "block.minecraft.spruce_log": "Труп од смрека",
  "block.minecraft.spruce_planks": "Даски од смрека",
  "block.minecraft.spruce_pressure_plate": "Притисна плоча од смрека",
  "block.minecraft.spruce_sapling": "Фиданка од смрека",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "Знак од смрека",
  "block.minecraft.spruce_slab": "Плоча од смрека",
  "block.minecraft.spruce_stairs": "Скали од смрека",
  "block.minecraft.spruce_trapdoor": "Врата-стапица од смрека",
  "block.minecraft.spruce_wall_hanging_sign": "Висечки знак од смрека",
  "block.minecraft.spruce_wall_sign": "Ѕиден знак од смрека",
  "block.minecraft.spruce_wood": "Смрека",
  "block.minecraft.sticky_piston": "Леплив клип",
  "block.minecraft.stone": "Камен",
  "block.minecraft.stone_brick_slab": "Плоча од камени цигли",
  "block.minecraft.stone_brick_stairs": "Скали од камени цигли",
  "block.minecraft.stone_brick_wall": "Ѕид од камени цигли",
  "block.minecraft.stone_bricks": "Камени цигли",
  "block.minecraft.stone_button": "Копче од камен",
  "block.minecraft.stone_pressure_plate": "Камена притисна плоча",
  "block.minecraft.stone_slab": "Камена плоча",
  "block.minecraft.stone_stairs": "Камени скали",
  "block.minecraft.stonecutter": "Каменорезец",
  "block.minecraft.stripped_acacia_log": "Соголен труп од акација",
  "block.minecraft.stripped_acacia_wood": "Соголена акација",
  "block.minecraft.stripped_bamboo_block": "Block of Stripped Bamboo",
  "block.minecraft.stripped_birch_log": "Соголен труп од бреза",
  "block.minecraft.stripped_birch_wood": "Соголена бреза",
  "block.minecraft.stripped_cherry_log": "Stripped Cherry Log",
  "block.minecraft.stripped_cherry_wood": "Stripped Cherry Wood",
  "block.minecraft.stripped_crimson_hyphae": "Истрижани Црвени Хифи",
  "block.minecraft.stripped_crimson_stem": "Истрижано Црвено Стебло",
  "block.minecraft.stripped_dark_oak_log": "Соголен труп од темен даб",
  "block.minecraft.stripped_dark_oak_wood": "Соголен темен даб",
  "block.minecraft.stripped_jungle_log": "Соголен труп од џунглиско дрво",
  "block.minecraft.stripped_jungle_wood": "Соголено џунглиско дрво",
  "block.minecraft.stripped_mangrove_log": "Соголен труп од мангрово дрво",
  "block.minecraft.stripped_mangrove_wood": "Соголено мангрово дрво",
  "block.minecraft.stripped_oak_log": "Соголен труп од даб",
  "block.minecraft.stripped_oak_wood": "Соголен даб",
  "block.minecraft.stripped_pale_oak_log": "Stripped Pale Oak Log",
  "block.minecraft.stripped_pale_oak_wood": "Stripped Pale Oak Wood",
  "block.minecraft.stripped_spruce_log": "Соголен труп од смрека",
  "block.minecraft.stripped_spruce_wood": "Соголена смрека",
  "block.minecraft.stripped_warped_hyphae": "Истрижани Луди Хифи",
  "block.minecraft.stripped_warped_stem": "Истрижано Лудо Стебло",
  "block.minecraft.structure_block": "Структурен блок",
  "block.minecraft.structure_void": "Структурна празнина",
  "block.minecraft.sugar_cane": "Шеќерна трска",
  "block.minecraft.sunflower": "Сончоглед",
  "block.minecraft.suspicious_gravel": "Сомнитен Грагор",
  "block.minecraft.suspicious_sand": "Suspicious Sand",
  "block.minecraft.sweet_berry_bush": "Грмушка со слатки бобинки",
  "block.minecraft.tall_dry_grass": "Tall Dry Grass",
  "block.minecraft.tall_grass": "Висока трева",
  "block.minecraft.tall_seagrass": "Висока морска трева",
  "block.minecraft.target": "Мета",
  "block.minecraft.terracotta": "Теракота",
  "block.minecraft.test_block": "Test Block",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "Затемнето стакло",
  "block.minecraft.tnt": "ТНТ",
  "block.minecraft.tnt.disabled": "TNT explosions are disabled",
  "block.minecraft.torch": "Факел",
  "block.minecraft.torchflower": "Факел цвет",
  "block.minecraft.torchflower_crop": "Torchflower Crop",
  "block.minecraft.trapped_chest": "Сандак-стапица",
  "block.minecraft.trial_spawner": "Trial Spawner",
  "block.minecraft.tripwire": "Нагазна жица",
  "block.minecraft.tripwire_hook": "Кука за нагазна жица",
  "block.minecraft.tube_coral": "Цевчест корал",
  "block.minecraft.tube_coral_block": "Цевчест корален блок",
  "block.minecraft.tube_coral_fan": "Цевчеста корална лепеза",
  "block.minecraft.tube_coral_wall_fan": "Ѕидна цевчеста корална лепеза",
  "block.minecraft.tuff": "Туф",
  "block.minecraft.tuff_brick_slab": "Tuff Brick Slab",
  "block.minecraft.tuff_brick_stairs": "Tuff Brick Stairs",
  "block.minecraft.tuff_brick_wall": "Tuff Brick Wall",
  "block.minecraft.tuff_bricks": "Tuff Bricks",
  "block.minecraft.tuff_slab": "Tuff Slab",
  "block.minecraft.tuff_stairs": "Tuff Stairs",
  "block.minecraft.tuff_wall": "Tuff Wall",
  "block.minecraft.turtle_egg": "Јајце од желка",
  "block.minecraft.twisting_vines": "Вртени Гранки",
  "block.minecraft.twisting_vines_plant": "Вртени Гранки Билка",
  "block.minecraft.vault": "Vault",
  "block.minecraft.verdant_froglight": "Светло жаби",
  "block.minecraft.vine": "Лози",
  "block.minecraft.void_air": "Празен воздух",
  "block.minecraft.wall_torch": "Ѕиден факел",
  "block.minecraft.warped_button": "Лудо Копче",
  "block.minecraft.warped_door": "Луда Врата",
  "block.minecraft.warped_fence": "Луда Ограда",
  "block.minecraft.warped_fence_gate": "Луда Порта",
  "block.minecraft.warped_fungus": "Луд Корен",
  "block.minecraft.warped_hanging_sign": "Сино-зелен висечки знак",
  "block.minecraft.warped_hyphae": "Луди Хифи",
  "block.minecraft.warped_nylium": "Луд Пеколцелиум",
  "block.minecraft.warped_planks": "Луди Билки",
  "block.minecraft.warped_pressure_plate": "Луда Притисочна Плочка",
  "block.minecraft.warped_roots": "Луди Корени",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Луд Знак",
  "block.minecraft.warped_slab": "Луда Плочка",
  "block.minecraft.warped_stairs": "Луди Скали",
  "block.minecraft.warped_stem": "Искривенo Стебло",
  "block.minecraft.warped_trapdoor": "Луда Подна Врата",
  "block.minecraft.warped_wall_hanging_sign": "Сино-зелен висечки знак",
  "block.minecraft.warped_wall_sign": "Луди Зидни Знак",
  "block.minecraft.warped_wart_block": "Луда Бубуљична Коцка",
  "block.minecraft.water": "Вода",
  "block.minecraft.water_cauldron": "Казан со вода",
  "block.minecraft.waxed_chiseled_copper": "Waxed Chiseled Copper",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Блок Бакар обложен со восок",
  "block.minecraft.waxed_copper_bulb": "Waxed Copper Bulb",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Восочна бакарна врата",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Восочна бакарна порта",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Waxed Copper Trapdoor",
  "block.minecraft.waxed_cut_copper": "Сечен бакар обложен со восок",
  "block.minecraft.waxed_cut_copper_slab": "Плоча од сечен бакар обложена со восок",
  "block.minecraft.waxed_cut_copper_stairs": "Скали од сечен бакар обложени со восок",
  "block.minecraft.waxed_exposed_chiseled_copper": "Waxed Exposed Chiseled Copper",
  "block.minecraft.waxed_exposed_copper": "Изложен бакар обложен со восок",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Waxed Exposed Copper Bulb",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Waxed Exposed Copper Door",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Waxed Exposed Copper Grate",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Waxed Exposed Copper Trapdoor",
  "block.minecraft.waxed_exposed_cut_copper": "Изложен сечен бакар обложен со восок",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Изложена плоча од сечениот бакар обложена со восок",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Изложени скали од сечен бакар обложени со восок",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Waxed Oxidized Chiseled Copper",
  "block.minecraft.waxed_oxidized_copper": "Оксидиран бакар обложен со восок",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Waxed Oxidized Copper Bulb",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Waxed Oxidized Copper Door",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Waxed Oxidized Copper Grate",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Waxed Oxidized Copper Trapdoor",
  "block.minecraft.waxed_oxidized_cut_copper": "Оксидиран сечен бакар обложен со восок",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Оксидирана плоча од сечен бакар обложена со восок",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Скали од сечен бакар облежени со восок",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Waxed Weathered Chiseled Copper",
  "block.minecraft.waxed_weathered_copper": "Застарен бакар обложен со восок",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Waxed Weathered Copper Bulb",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Waxed Weathered Copper Door",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Waxed Weathered Copper Grate",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Waxed Weathered Copper Trapdoor",
  "block.minecraft.waxed_weathered_cut_copper": "Застарен сечен бакар обложен со восок",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Застарена плоча од сечен бакар обложена со восок",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Застарени скали од сечен бакар обложени со восок",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Weathered Chiseled Copper",
  "block.minecraft.weathered_copper": "Оксидиран бакар",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Weathered Copper Bulb",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Weathered Copper Door",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Weathered Copper Grate",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Weathered Copper Trapdoor",
  "block.minecraft.weathered_cut_copper": "Оксидиран сечен бакар",
  "block.minecraft.weathered_cut_copper_slab": "Оксидирана плоча од сечен бакар",
  "block.minecraft.weathered_cut_copper_stairs": "Оксидирани скали од сечен бакар",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Тажни Гранки",
  "block.minecraft.weeping_vines_plant": "Тажни Гранки Билка",
  "block.minecraft.wet_sponge": "Влажен сунѓер",
  "block.minecraft.wheat": "Пченична култура",
  "block.minecraft.white_banner": "Бел банер",
  "block.minecraft.white_bed": "Бел кревет",
  "block.minecraft.white_candle": "Бела свеќа",
  "block.minecraft.white_candle_cake": "Торта со Бела Свеќа",
  "block.minecraft.white_carpet": "Бел тепих",
  "block.minecraft.white_concrete": "Бел бетон",
  "block.minecraft.white_concrete_powder": "Бел бетон во прав",
  "block.minecraft.white_glazed_terracotta": "Бела глазирана теракота",
  "block.minecraft.white_shulker_box": "Бела шулкер кутија",
  "block.minecraft.white_stained_glass": "Бело стакло",
  "block.minecraft.white_stained_glass_pane": "Бела стаклена рамка",
  "block.minecraft.white_terracotta": "Бела теракота",
  "block.minecraft.white_tulip": "Бело лале",
  "block.minecraft.white_wool": "Бела волна",
  "block.minecraft.wildflowers": "Wildflowers",
  "block.minecraft.wither_rose": "Видер роза",
  "block.minecraft.wither_skeleton_skull": "Череп од видер скелет",
  "block.minecraft.wither_skeleton_wall_skull": "Ѕиден череп од видер скелет",
  "block.minecraft.yellow_banner": "Жолт банер",
  "block.minecraft.yellow_bed": "Жолт кревет",
  "block.minecraft.yellow_candle": "Жолта свеќа",
  "block.minecraft.yellow_candle_cake": "Торта со Жолта Свеќа",
  "block.minecraft.yellow_carpet": "Жолт тепих",
  "block.minecraft.yellow_concrete": "Жолт бетон",
  "block.minecraft.yellow_concrete_powder": "Жолт бетон во прав",
  "block.minecraft.yellow_glazed_terracotta": "Жолта глазирана теракота",
  "block.minecraft.yellow_shulker_box": "Жолта шулкер кутија",
  "block.minecraft.yellow_stained_glass": "Жолто стакло",
  "block.minecraft.yellow_stained_glass_pane": "Жолта стаклена рамка",
  "block.minecraft.yellow_terracotta": "Жолта теракота",
  "block.minecraft.yellow_wool": "Жолта волна",
  "block.minecraft.zombie_head": "Глава од зомби",
  "block.minecraft.zombie_wall_head": "Ѕидна глава од зомби",
  "item.minecraft.acacia_boat": "Чамец од акација",
  "item.minecraft.acacia_chest_boat": "Чамец од багрем со ковчег",
  "item.minecraft.allay_spawn_egg": "Јајце за создавање Алеј",
  "item.minecraft.amethyst_shard": "Аметист Шард",
  "item.minecraft.angler_pottery_shard": "Angler Pottery Shard",
  "item.minecraft.angler_pottery_sherd": "Angler Pottery Sherd",
  "item.minecraft.apple": "Јаболко",
  "item.minecraft.archer_pottery_shard": "Archer Pottery Shard",
  "item.minecraft.archer_pottery_sherd": "Archer Pottery Sherd",
  "item.minecraft.armadillo_scute": "Armadillo Scute",
  "item.minecraft.armadillo_spawn_egg": "Armadillo Spawn Egg",
  "item.minecraft.armor_stand": "Држач за оклоп",
  "item.minecraft.arms_up_pottery_shard": "Arms Up Pottery Shard",
  "item.minecraft.arms_up_pottery_sherd": "Arms Up Pottery Sherd",
  "item.minecraft.arrow": "Стрела",
  "item.minecraft.axolotl_bucket": "Кофа со Аксолотл",
  "item.minecraft.axolotl_spawn_egg": "Створувач на аксолотл",
  "item.minecraft.baked_potato": "Печен компир",
  "item.minecraft.bamboo_chest_raft": "Бамбyсов сплоф со кофчег",
  "item.minecraft.bamboo_raft": "Бамбусов сплав",
  "item.minecraft.bat_spawn_egg": "Јајце за создавање лилјак",
  "item.minecraft.bee_spawn_egg": "Јајце за создавање пчела",
  "item.minecraft.beef": "Сурово говедско месо",
  "item.minecraft.beetroot": "Цвекло",
  "item.minecraft.beetroot_seeds": "Семе од цвекло",
  "item.minecraft.beetroot_soup": "Супа од цвекло",
  "item.minecraft.birch_boat": "Чамец од бреза",
  "item.minecraft.birch_chest_boat": "Чамец од бреза со ковчег",
  "item.minecraft.black_bundle": "Black Bundle",
  "item.minecraft.black_dye": "Црна фарба",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "Blade Pottery Shard",
  "item.minecraft.blade_pottery_sherd": "Blade Pottery Sherd",
  "item.minecraft.blaze_powder": "Пламен прав",
  "item.minecraft.blaze_rod": "Пламена прачка",
  "item.minecraft.blaze_spawn_egg": "Јајце за создавање пламен",
  "item.minecraft.blue_bundle": "Blue Bundle",
  "item.minecraft.blue_dye": "Сина фарба",
  "item.minecraft.blue_egg": "Blue Egg",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "Bogged Spawn Egg",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Armor Trim",
  "item.minecraft.bone": "Коска",
  "item.minecraft.bone_meal": "Коскено брашно",
  "item.minecraft.book": "Книга",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "Лак",
  "item.minecraft.bowl": "Чинија",
  "item.minecraft.bread": "Леб",
  "item.minecraft.breeze_rod": "Breeze Rod",
  "item.minecraft.breeze_spawn_egg": "Breeze Spawn Egg",
  "item.minecraft.brewer_pottery_shard": "Brewer Pottery Shard",
  "item.minecraft.brewer_pottery_sherd": "Brewer Pottery Sherd",
  "item.minecraft.brewing_stand": "Штанд за подготовка",
  "item.minecraft.brick": "Цигла",
  "item.minecraft.brown_bundle": "Brown Bundle",
  "item.minecraft.brown_dye": "Кафеава фарба",
  "item.minecraft.brown_egg": "Brown Egg",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "Четка",
  "item.minecraft.bucket": "Кофа",
  "item.minecraft.bundle": "Пакет",
  "item.minecraft.bundle.empty": "Empty",
  "item.minecraft.bundle.empty.description": "Can hold a mixed stack of items",
  "item.minecraft.bundle.full": "Full",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Burn Pottery Shard",
  "item.minecraft.burn_pottery_sherd": "Burn Pottery Sherd",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Јајце за создавање Камили",
  "item.minecraft.carrot": "Морков",
  "item.minecraft.carrot_on_a_stick": "Морков на стап",
  "item.minecraft.cat_spawn_egg": "Јајце за создавање мачка",
  "item.minecraft.cauldron": "Котел",
  "item.minecraft.cave_spider_spawn_egg": "Јајце за создавање пештерски пајак",
  "item.minecraft.chainmail_boots": "Верижни чизми",
  "item.minecraft.chainmail_chestplate": "Верижен оклоп",
  "item.minecraft.chainmail_helmet": "Верижен шлем",
  "item.minecraft.chainmail_leggings": "Верижни панталони",
  "item.minecraft.charcoal": "Ќумур",
  "item.minecraft.cherry_boat": "Црешово дрво",
  "item.minecraft.cherry_chest_boat": "Cherry Boat with Chest",
  "item.minecraft.chest_minecart": "Рударска количка со сандак",
  "item.minecraft.chicken": "Сурова кокошка",
  "item.minecraft.chicken_spawn_egg": "Јајце за создавање кокошка",
  "item.minecraft.chorus_fruit": "Хорус овошје",
  "item.minecraft.clay_ball": "Глинена Топка",
  "item.minecraft.clock": "Часовник",
  "item.minecraft.coal": "Јаглен",
  "item.minecraft.coast_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast Armor Trim",
  "item.minecraft.cocoa_beans": "Какаови зрна",
  "item.minecraft.cod": "Суров бакалар",
  "item.minecraft.cod_bucket": "Кофа со бакалар",
  "item.minecraft.cod_spawn_egg": "Јајце за создавање бакалар",
  "item.minecraft.command_block_minecart": "Рударска количка со команден блок",
  "item.minecraft.compass": "Компас",
  "item.minecraft.cooked_beef": "Бифтек",
  "item.minecraft.cooked_chicken": "Печена кокошка",
  "item.minecraft.cooked_cod": "Печен бакалар",
  "item.minecraft.cooked_mutton": "Печено овчо месо",
  "item.minecraft.cooked_porkchop": "Печено свинско месо",
  "item.minecraft.cooked_rabbit": "Печен зајак",
  "item.minecraft.cooked_salmon": "Печен лосос",
  "item.minecraft.cookie": "Колаче",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "Бакарен калап",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "Јајце за создавање крава",
  "item.minecraft.creaking_spawn_egg": "Creaking Spawn Egg",
  "item.minecraft.creeper_banner_pattern": "Шема за банер",
  "item.minecraft.creeper_banner_pattern.desc": "Фигура на крипер",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "Јајце за создавање крипер",
  "item.minecraft.crossbow": "Самострел",
  "item.minecraft.crossbow.projectile": "Проектил:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Cyan Bundle",
  "item.minecraft.cyan_dye": "Сино-зелена фарба",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "Danger Pottery Shard",
  "item.minecraft.danger_pottery_sherd": "Danger Pottery Sherd",
  "item.minecraft.dark_oak_boat": "Чамец од темен даб",
  "item.minecraft.dark_oak_chest_boat": "Темен дабов чамец со ковчег",
  "item.minecraft.debug_stick": "Стап за откривање грешки",
  "item.minecraft.debug_stick.empty": "%s нема својства",
  "item.minecraft.debug_stick.select": "избрано \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" на %s",
  "item.minecraft.diamond": "Дијамант",
  "item.minecraft.diamond_axe": "Дијамантска секира",
  "item.minecraft.diamond_boots": "Дијамантски чизми",
  "item.minecraft.diamond_chestplate": "Дијамантски оклоп",
  "item.minecraft.diamond_helmet": "Дијамантски шлем",
  "item.minecraft.diamond_hoe": "Дијамантска мотика",
  "item.minecraft.diamond_horse_armor": "Дијамантски коњски оклоп",
  "item.minecraft.diamond_leggings": "Дијамантски панталони",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Дијамантски копач",
  "item.minecraft.diamond_shovel": "Дијамантска лопата",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Дијамантски меч",
  "item.minecraft.disc_fragment_5": "Парче диск",
  "item.minecraft.disc_fragment_5.desc": "Музички Диск - 5",
  "item.minecraft.dolphin_spawn_egg": "Јајце за создавање делфин",
  "item.minecraft.donkey_spawn_egg": "Јајце за создавање магаре",
  "item.minecraft.dragon_breath": "Змејски здив",
  "item.minecraft.dried_kelp": "Исушена алга",
  "item.minecraft.drowned_spawn_egg": "Јајце за создавање удавен",
  "item.minecraft.dune_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dune Armor Trim",
  "item.minecraft.echo_shard": "Ехо Шард",
  "item.minecraft.egg": "Јајце",
  "item.minecraft.elder_guardian_spawn_egg": "Јајце за создавање чувар старешина",
  "item.minecraft.elytra": "Крила",
  "item.minecraft.emerald": "Смарагд",
  "item.minecraft.enchanted_book": "Волшебна книга",
  "item.minecraft.enchanted_golden_apple": "Маѓепсано златно јаболко",
  "item.minecraft.end_crystal": "Енд кристал",
  "item.minecraft.ender_dragon_spawn_egg": "Јајце за создавање на ендер змеј",
  "item.minecraft.ender_eye": "Ендер око",
  "item.minecraft.ender_pearl": "Ендер бисер",
  "item.minecraft.enderman_spawn_egg": "Јајце за создавање ендермен",
  "item.minecraft.endermite_spawn_egg": "Јајце за создавање ендермит",
  "item.minecraft.evoker_spawn_egg": "Јајце за создавање повикувач",
  "item.minecraft.experience_bottle": "Волшебно шише",
  "item.minecraft.explorer_pottery_shard": "Explorer Pottery Shard",
  "item.minecraft.explorer_pottery_sherd": "Explorer Pottery Sherd",
  "item.minecraft.eye_armor_trim_smithing_template": "Шаблон за ковање",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eye Armor Trim",
  "item.minecraft.feather": "Пердув",
  "item.minecraft.fermented_spider_eye": "Ферментирано око од пајак",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "Карта",
  "item.minecraft.fire_charge": "Огнена топка",
  "item.minecraft.firework_rocket": "Огнометна ракета",
  "item.minecraft.firework_rocket.flight": "Траење на летот:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Огнометна ѕвезда",
  "item.minecraft.firework_star.black": "Црна",
  "item.minecraft.firework_star.blue": "Сина",
  "item.minecraft.firework_star.brown": "Кафеава",
  "item.minecraft.firework_star.custom_color": "Прилагодена",
  "item.minecraft.firework_star.cyan": "Сино-зелена",
  "item.minecraft.firework_star.fade_to": "Бледнее во",
  "item.minecraft.firework_star.flicker": "Треперење",
  "item.minecraft.firework_star.gray": "Сива",
  "item.minecraft.firework_star.green": "Зелена",
  "item.minecraft.firework_star.light_blue": "Светлосина",
  "item.minecraft.firework_star.light_gray": "Светлосива",
  "item.minecraft.firework_star.lime": "Жолто-зелена",
  "item.minecraft.firework_star.magenta": "Магента",
  "item.minecraft.firework_star.orange": "Портокалова",
  "item.minecraft.firework_star.pink": "Розова",
  "item.minecraft.firework_star.purple": "Виолетова",
  "item.minecraft.firework_star.red": "Црвена",
  "item.minecraft.firework_star.shape": "Непозната форма",
  "item.minecraft.firework_star.shape.burst": "Распрснување",
  "item.minecraft.firework_star.shape.creeper": "Облик на крипер",
  "item.minecraft.firework_star.shape.large_ball": "Голема топка",
  "item.minecraft.firework_star.shape.small_ball": "Мала топка",
  "item.minecraft.firework_star.shape.star": "Облик на ѕвезда",
  "item.minecraft.firework_star.trail": "Опашка",
  "item.minecraft.firework_star.white": "Бела",
  "item.minecraft.firework_star.yellow": "Жолта",
  "item.minecraft.fishing_rod": "Трска за риболов",
  "item.minecraft.flint": "Кремен",
  "item.minecraft.flint_and_steel": "Запалка",
  "item.minecraft.flow_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Armor Trim",
  "item.minecraft.flow_banner_pattern": "Banner Pattern",
  "item.minecraft.flow_banner_pattern.desc": "Тек",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Flow Pottery Sherd",
  "item.minecraft.flower_banner_pattern": "Шема за банер",
  "item.minecraft.flower_banner_pattern.desc": "Фигура на цвет",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "Саксија",
  "item.minecraft.fox_spawn_egg": "Јајце за создавање лисица",
  "item.minecraft.friend_pottery_shard": "Friend Pottery Shard",
  "item.minecraft.friend_pottery_sherd": "Friend Pottery Sherd",
  "item.minecraft.frog_spawn_egg": "Јајце за создавање на Жаба",
  "item.minecraft.furnace_minecart": "Рударска количка со печка",
  "item.minecraft.ghast_spawn_egg": "Јајце за создавање гаст",
  "item.minecraft.ghast_tear": "Солза од гаст",
  "item.minecraft.glass_bottle": "Стаклено шише",
  "item.minecraft.glistering_melon_slice": "Сјајно парче од лубеница",
  "item.minecraft.globe_banner_pattern": "Шема за банер",
  "item.minecraft.globe_banner_pattern.desc": "Глобус",
  "item.minecraft.globe_banner_pattern.new": "Globe Banner Pattern",
  "item.minecraft.glow_berries": "Сјајни бобинки",
  "item.minecraft.glow_ink_sac": "Сјајно мастило сак",
  "item.minecraft.glow_item_frame": "Сјајна рамка на предметот",
  "item.minecraft.glow_squid_spawn_egg": "Створувач на светли лигњи",
  "item.minecraft.glowstone_dust": "Прашина од светлосен камен",
  "item.minecraft.goat_horn": "Јарец рог",
  "item.minecraft.goat_spawn_egg": "Створувач на кози",
  "item.minecraft.gold_ingot": "Златен калап",
  "item.minecraft.gold_nugget": "Златна грутка",
  "item.minecraft.golden_apple": "Златно Јаболко",
  "item.minecraft.golden_axe": "Златна секира",
  "item.minecraft.golden_boots": "Златни чизми",
  "item.minecraft.golden_carrot": "Златен морков",
  "item.minecraft.golden_chestplate": "Златен оклоп",
  "item.minecraft.golden_helmet": "Златен шлем",
  "item.minecraft.golden_hoe": "Златна мотика",
  "item.minecraft.golden_horse_armor": "Златен коњски оклоп",
  "item.minecraft.golden_leggings": "Златни панталони",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Златен копач",
  "item.minecraft.golden_shovel": "Златна лопата",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Златен меч",
  "item.minecraft.gray_bundle": "Gray Bundle",
  "item.minecraft.gray_dye": "Сива фарба",
  "item.minecraft.gray_harness": "Gray Harness",
  "item.minecraft.green_bundle": "Green Bundle",
  "item.minecraft.green_dye": "Зелена фарба",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "Јајце за создавање чувар",
  "item.minecraft.gunpowder": "Барут",
  "item.minecraft.guster_banner_pattern": "Banner Pattern",
  "item.minecraft.guster_banner_pattern.desc": "Guster",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Happy Ghast Spawn Egg",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "Срцето на морето",
  "item.minecraft.heart_pottery_shard": "Heart Pottery Shard",
  "item.minecraft.heart_pottery_sherd": "Heart Pottery Sherd",
  "item.minecraft.heartbreak_pottery_shard": "Heartbreak Pottery Shard",
  "item.minecraft.heartbreak_pottery_sherd": "Heartbreak Pottery Sherd",
  "item.minecraft.hoglin_spawn_egg": "Јајце за Создавање Пеколска Свиња",
  "item.minecraft.honey_bottle": "Шише со мед",
  "item.minecraft.honeycomb": "Саќе",
  "item.minecraft.hopper_minecart": "Рударска количка со собирач",
  "item.minecraft.horse_spawn_egg": "Јајце за создавање коњ",
  "item.minecraft.host_armor_trim_smithing_template": "Шаблон за ковање",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "Howl Pottery Shard",
  "item.minecraft.howl_pottery_sherd": "Howl Pottery Sherd",
  "item.minecraft.husk_spawn_egg": "Јајце за создавање пустинско зомби",
  "item.minecraft.ink_sac": "Вреќичка со мастило",
  "item.minecraft.iron_axe": "Железна секира",
  "item.minecraft.iron_boots": "Железни чизми",
  "item.minecraft.iron_chestplate": "Железен оклоп",
  "item.minecraft.iron_golem_spawn_egg": "Јајце за создавање на железен голем",
  "item.minecraft.iron_helmet": "Железен шлем",
  "item.minecraft.iron_hoe": "Железна мотика",
  "item.minecraft.iron_horse_armor": "Железен коњски оклоп",
  "item.minecraft.iron_ingot": "Железен калап",
  "item.minecraft.iron_leggings": "Железни панталони",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Железна грутка",
  "item.minecraft.iron_pickaxe": "Железен копач",
  "item.minecraft.iron_shovel": "Железна лопата",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "Железен меч",
  "item.minecraft.item_frame": "Рамка",
  "item.minecraft.jungle_boat": "Чамец од џунглиско дрво",
  "item.minecraft.jungle_chest_boat": "Чамец со ковчег",
  "item.minecraft.knowledge_book": "Книга на знаење",
  "item.minecraft.lapis_lazuli": "Лазура",
  "item.minecraft.lava_bucket": "Кофа со лава",
  "item.minecraft.lead": "Ортома",
  "item.minecraft.leather": "Кожа",
  "item.minecraft.leather_boots": "Кожни чизми",
  "item.minecraft.leather_chestplate": "Кожна туника",
  "item.minecraft.leather_helmet": "Кожна капа",
  "item.minecraft.leather_horse_armor": "Кожен коњски оклоп",
  "item.minecraft.leather_leggings": "Кожни панталони",
  "item.minecraft.light_blue_bundle": "Light Blue Bundle",
  "item.minecraft.light_blue_dye": "Светлосина фарба",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "Light Gray Bundle",
  "item.minecraft.light_gray_dye": "Светлосива фарба",
  "item.minecraft.light_gray_harness": "Light Gray Harness",
  "item.minecraft.lime_bundle": "Lime Bundle",
  "item.minecraft.lime_dye": "Зелена фарба",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "Лебдечка напивка",
  "item.minecraft.lingering_potion.effect.awkward": "Непријатна лебдечка напивка",
  "item.minecraft.lingering_potion.effect.empty": "Несоздавачка лебдечка напивка",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Лебдечка напивка за отпорност на оган",
  "item.minecraft.lingering_potion.effect.harming": "Лебдечка напивка за повредување",
  "item.minecraft.lingering_potion.effect.healing": "Лебдечка напивка за лекување",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion of Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "Лебдечка напивка за невидливост",
  "item.minecraft.lingering_potion.effect.leaping": "Лебдечка напивка за скокање",
  "item.minecraft.lingering_potion.effect.levitation": "Лебдечка напивка за левитација",
  "item.minecraft.lingering_potion.effect.luck": "Лебдечка напивка за среќа",
  "item.minecraft.lingering_potion.effect.mundane": "Обична лебдечка напивка",
  "item.minecraft.lingering_potion.effect.night_vision": "Лебдечка напивка за ноќно гледање",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "Лебдечка напивка за труење",
  "item.minecraft.lingering_potion.effect.regeneration": "Лебдечка напивка за регенерација",
  "item.minecraft.lingering_potion.effect.slow_falling": "Лебдечка напивка за бавно паѓање",
  "item.minecraft.lingering_potion.effect.slowness": "Лебдечка напивка за бавност",
  "item.minecraft.lingering_potion.effect.strength": "Лебдечка напивка за сила",
  "item.minecraft.lingering_potion.effect.swiftness": "Лебдечка напивка за брзина",
  "item.minecraft.lingering_potion.effect.thick": "Густа лебдечка напивка",
  "item.minecraft.lingering_potion.effect.turtle_master": "Лебдечка напивка на господарот на желките",
  "item.minecraft.lingering_potion.effect.water": "Лебдечко шише со вода",
  "item.minecraft.lingering_potion.effect.water_breathing": "Лебдечка напивка за дишење под вода",
  "item.minecraft.lingering_potion.effect.weakness": "Лебдечка напивка за слабост",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "Јајце за создавање лама",
  "item.minecraft.lodestone_compass": "Компас за Магнетен Камен",
  "item.minecraft.mace": "Боздоган",
  "item.minecraft.magenta_bundle": "Magenta Bundle",
  "item.minecraft.magenta_dye": "Магента фарба",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "Магма крем",
  "item.minecraft.magma_cube_spawn_egg": "Јајце за создавање магма коцка",
  "item.minecraft.mangrove_boat": "Мангровен чамец",
  "item.minecraft.mangrove_chest_boat": "Мангров чамец со ковчег",
  "item.minecraft.map": "Празна карта",
  "item.minecraft.melon_seeds": "Семки од лубеница",
  "item.minecraft.melon_slice": "Парче лубеница",
  "item.minecraft.milk_bucket": "Кофа со млеко",
  "item.minecraft.minecart": "Рударска количка",
  "item.minecraft.miner_pottery_shard": "Miner Pottery Shard",
  "item.minecraft.miner_pottery_sherd": "Miner Pottery Sherd",
  "item.minecraft.mojang_banner_pattern": "Шема за банер",
  "item.minecraft.mojang_banner_pattern.desc": "Нешто",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "Јајце за создавање муушрум",
  "item.minecraft.mourner_pottery_shard": "Mourner Pottery Shard",
  "item.minecraft.mourner_pottery_sherd": "Mourner Pottery Sherd",
  "item.minecraft.mule_spawn_egg": "Јајце за создавање муле",
  "item.minecraft.mushroom_stew": "Чорба од печурки",
  "item.minecraft.music_disc_11": "Музички диск",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Музички диск",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Музички диск",
  "item.minecraft.music_disc_5.desc": "Самуел Аберг - 5",
  "item.minecraft.music_disc_blocks": "Музички диск",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Музички диск",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Музички диск",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Music Disc",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Music Disc",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Музички диск",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Music Disc",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Музички диск",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Музички диск",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Музички Диск",
  "item.minecraft.music_disc_otherside.desc": "Лена Раине - другата страна",
  "item.minecraft.music_disc_pigstep": "Музички диск",
  "item.minecraft.music_disc_pigstep.desc": "Лена Раин - Pigstep",
  "item.minecraft.music_disc_precipice": "Music Disc",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Музика диск",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Музички диск",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Музички диск",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Музички диск",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Музички диск",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Сурово овчо месо",
  "item.minecraft.name_tag": "Ознака за име",
  "item.minecraft.nautilus_shell": "Наутилус школка",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Недер цигла",
  "item.minecraft.nether_star": "Недер ѕвезда",
  "item.minecraft.nether_wart": "Недер лишај",
  "item.minecraft.netherite_axe": "Пеколитски секира",
  "item.minecraft.netherite_boots": "Пеколитски Чизми",
  "item.minecraft.netherite_chestplate": "Пеколитска Мајца",
  "item.minecraft.netherite_helmet": "Пеколитски Шлем",
  "item.minecraft.netherite_hoe": "Пеколитска Мотика",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Пеколитски ингот",
  "item.minecraft.netherite_leggings": "Пеколитски Панталони",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Пеколитски копач",
  "item.minecraft.netherite_scrap": "Парче Пеколит",
  "item.minecraft.netherite_shovel": "Пеколитска Лопатка",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Пеколитски Меч",
  "item.minecraft.netherite_upgrade_smithing_template": "Smithing Template",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite Upgrade",
  "item.minecraft.oak_boat": "Чамец од даб",
  "item.minecraft.oak_chest_boat": "Дабов чамец со ковчег",
  "item.minecraft.ocelot_spawn_egg": "Јајце за создавање оцелот",
  "item.minecraft.ominous_bottle": "Ominous Bottle",
  "item.minecraft.ominous_trial_key": "Ominous Trial Key",
  "item.minecraft.orange_bundle": "Orange Bundle",
  "item.minecraft.orange_dye": "Портокалова фарба",
  "item.minecraft.orange_harness": "Orange Harness",
  "item.minecraft.painting": "Слика",
  "item.minecraft.pale_oak_boat": "Pale Oak Boat",
  "item.minecraft.pale_oak_chest_boat": "Pale Oak Boat with Chest",
  "item.minecraft.panda_spawn_egg": "Јајце за создавање панда",
  "item.minecraft.paper": "Хартија",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Јајце за создавање папагал",
  "item.minecraft.phantom_membrane": "Фантомска мембрана",
  "item.minecraft.phantom_spawn_egg": "Јајце за создавање фантом",
  "item.minecraft.pig_spawn_egg": "Јајце за создавање прасе",
  "item.minecraft.piglin_banner_pattern": "Шема за банер",
  "item.minecraft.piglin_banner_pattern.desc": "Муцка",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "Брутален Пиглин Jајце",
  "item.minecraft.piglin_spawn_egg": "Јајце за Создавање Свински Човек",
  "item.minecraft.pillager_spawn_egg": "Јајце за создавање разбојник",
  "item.minecraft.pink_bundle": "Pink Bundle",
  "item.minecraft.pink_dye": "Розова фарба",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "Pitcher Plant",
  "item.minecraft.pitcher_pod": "Pitcher Pod",
  "item.minecraft.plenty_pottery_shard": "Plenty Pottery Shard",
  "item.minecraft.plenty_pottery_sherd": "Plenty Pottery Sherd",
  "item.minecraft.poisonous_potato": "Отворен компир",
  "item.minecraft.polar_bear_spawn_egg": "Јајце за создавање поларна мечка",
  "item.minecraft.popped_chorus_fruit": "Пукнато хорус овошје",
  "item.minecraft.porkchop": "Сурово свинско месо",
  "item.minecraft.potato": "Компир",
  "item.minecraft.potion": "Напивка",
  "item.minecraft.potion.effect.awkward": "Непријатна напивка",
  "item.minecraft.potion.effect.empty": "Несоздавачка напивка",
  "item.minecraft.potion.effect.fire_resistance": "Напивка за отпорност на оган",
  "item.minecraft.potion.effect.harming": "Напивка за повредување",
  "item.minecraft.potion.effect.healing": "Напивка за лекување",
  "item.minecraft.potion.effect.infested": "Potion of Infestation",
  "item.minecraft.potion.effect.invisibility": "Напивка за невидливост",
  "item.minecraft.potion.effect.leaping": "Напивка за скокање",
  "item.minecraft.potion.effect.levitation": "Напивка за левитација",
  "item.minecraft.potion.effect.luck": "Напивка за среќа",
  "item.minecraft.potion.effect.mundane": "Обична напивка",
  "item.minecraft.potion.effect.night_vision": "Напивка за ноќно гледање",
  "item.minecraft.potion.effect.oozing": "Potion of Oozing",
  "item.minecraft.potion.effect.poison": "Напивка за труење",
  "item.minecraft.potion.effect.regeneration": "Напивка за регенерација",
  "item.minecraft.potion.effect.slow_falling": "Напивка за бавно паѓање",
  "item.minecraft.potion.effect.slowness": "Напивка за бавност",
  "item.minecraft.potion.effect.strength": "Напивка за сила",
  "item.minecraft.potion.effect.swiftness": "Напивка за брзина",
  "item.minecraft.potion.effect.thick": "Густа напивка",
  "item.minecraft.potion.effect.turtle_master": "Напивка на господарот на желките",
  "item.minecraft.potion.effect.water": "Шише со вода",
  "item.minecraft.potion.effect.water_breathing": "Напивка за подводно дишење",
  "item.minecraft.potion.effect.weakness": "Напивка за слабост",
  "item.minecraft.potion.effect.weaving": "Potion of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Potion of Wind Charging",
  "item.minecraft.pottery_shard_archer": "Archer Pottery Shard",
  "item.minecraft.pottery_shard_arms_up": "Arms Up Pottery Shard",
  "item.minecraft.pottery_shard_prize": "Prize Pottery Shard",
  "item.minecraft.pottery_shard_skull": "Skull Pottery Shard",
  "item.minecraft.powder_snow_bucket": "Кофа за снег во прав",
  "item.minecraft.prismarine_crystals": "Призмарински кристал",
  "item.minecraft.prismarine_shard": "Призмаринска острица",
  "item.minecraft.prize_pottery_shard": "Prize Pottery Shard",
  "item.minecraft.prize_pottery_sherd": "Prize Pottery Sherd",
  "item.minecraft.pufferfish": "Риба-балон",
  "item.minecraft.pufferfish_bucket": "Кофа со риба-балон",
  "item.minecraft.pufferfish_spawn_egg": "Јајце за создавање риба-балон",
  "item.minecraft.pumpkin_pie": "Пита од тиква",
  "item.minecraft.pumpkin_seeds": "Семки од тиква",
  "item.minecraft.purple_bundle": "Purple Bundle",
  "item.minecraft.purple_dye": "Виолетова фарба",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "Недер кварц",
  "item.minecraft.rabbit": "Суров зајак",
  "item.minecraft.rabbit_foot": "Зајачка нога",
  "item.minecraft.rabbit_hide": "Зајачка кожа",
  "item.minecraft.rabbit_spawn_egg": "Јајце за создавање зајак",
  "item.minecraft.rabbit_stew": "Чорба од зајак",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "Јајце за создавање опустошител",
  "item.minecraft.raw_copper": "Суров бакар",
  "item.minecraft.raw_gold": "Сурово злато",
  "item.minecraft.raw_iron": "Сурово железо",
  "item.minecraft.recovery_compass": "Компас за обновување",
  "item.minecraft.red_bundle": "Red Bundle",
  "item.minecraft.red_dye": "Црвена фарба",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "Редстоун прашина",
  "item.minecraft.resin_brick": "Resin Brick",
  "item.minecraft.resin_clump": "Resin Clump",
  "item.minecraft.rib_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "Скапано месо",
  "item.minecraft.saddle": "Седло",
  "item.minecraft.salmon": "Суров лосос",
  "item.minecraft.salmon_bucket": "Кофа со лосос",
  "item.minecraft.salmon_spawn_egg": "Јајце за создавање лосос",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "Scute",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "Sheaf Pottery Shard",
  "item.minecraft.sheaf_pottery_sherd": "Sheaf Pottery Sherd",
  "item.minecraft.shears": "Ножици",
  "item.minecraft.sheep_spawn_egg": "Јајце за создавање овца",
  "item.minecraft.shelter_pottery_shard": "Shelter Pottery Shard",
  "item.minecraft.shelter_pottery_sherd": "Shelter Pottery Sherd",
  "item.minecraft.shield": "Штит",
  "item.minecraft.shield.black": "Црн штит",
  "item.minecraft.shield.blue": "Син штит",
  "item.minecraft.shield.brown": "Кафеав штит",
  "item.minecraft.shield.cyan": "Сино-зелен штит",
  "item.minecraft.shield.gray": "Сив штит",
  "item.minecraft.shield.green": "Зелен штит",
  "item.minecraft.shield.light_blue": "Светлосин штит",
  "item.minecraft.shield.light_gray": "Светлосив штит",
  "item.minecraft.shield.lime": "Лиметен штит",
  "item.minecraft.shield.magenta": "Магента штит",
  "item.minecraft.shield.orange": "Портокалов штит",
  "item.minecraft.shield.pink": "Розов штит",
  "item.minecraft.shield.purple": "Виолетов штит",
  "item.minecraft.shield.red": "Црвен штит",
  "item.minecraft.shield.white": "Бел штит",
  "item.minecraft.shield.yellow": "Жолт штит",
  "item.minecraft.shulker_shell": "Шулкер школка",
  "item.minecraft.shulker_spawn_egg": "Јајце за создавање шулкер",
  "item.minecraft.sign": "Знак",
  "item.minecraft.silence_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "Јајце за создавање сребрена риба",
  "item.minecraft.skeleton_horse_spawn_egg": "Јајце за создавање скелетен коњ",
  "item.minecraft.skeleton_spawn_egg": "Јајце за создавање скелет",
  "item.minecraft.skull_banner_pattern": "Шема за банер",
  "item.minecraft.skull_banner_pattern.desc": "Фигура на череп",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Skull Pottery Shard",
  "item.minecraft.skull_pottery_sherd": "Skull Pottery Sherd",
  "item.minecraft.slime_ball": "Слузна топка",
  "item.minecraft.slime_spawn_egg": "Јајце за создавање слуз",
  "item.minecraft.smithing_template": "Smithing Template",
  "item.minecraft.smithing_template.applies_to": "Applies to:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Add ingot or crystal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Оклоп",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Add a piece of armor",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Ingots & Crystals",
  "item.minecraft.smithing_template.ingredients": "Ingredients:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Add Netherite Ingot",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamond Equipment",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Add diamond armor, weapon, or tool",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherite Ingot",
  "item.minecraft.smithing_template.upgrade": "Надградба: ",
  "item.minecraft.sniffer_spawn_egg": "Sniffer Spawn Egg",
  "item.minecraft.snort_pottery_shard": "Snort Pottery Shard",
  "item.minecraft.snort_pottery_sherd": "Snort Pottery Sherd",
  "item.minecraft.snout_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "Snow Golem Spawn Egg",
  "item.minecraft.snowball": "Снежна топка",
  "item.minecraft.spectral_arrow": "Спектрална стрела",
  "item.minecraft.spider_eye": "Око од пајак",
  "item.minecraft.spider_spawn_egg": "Јајце за создавање пајак",
  "item.minecraft.spire_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "Распрскувачки напиток",
  "item.minecraft.splash_potion.effect.awkward": "Непријатна распрскувачка напивка",
  "item.minecraft.splash_potion.effect.empty": "Несоздавачка распрскувачка напивка",
  "item.minecraft.splash_potion.effect.fire_resistance": "Распрскувачка напивка за отпорност на оган",
  "item.minecraft.splash_potion.effect.harming": "Распрскувачка напивка за повредување",
  "item.minecraft.splash_potion.effect.healing": "Распрскувачка напивка за лекување",
  "item.minecraft.splash_potion.effect.infested": "Splash Potion of Infestation",
  "item.minecraft.splash_potion.effect.invisibility": "Распрскувачка напивка за невидливост",
  "item.minecraft.splash_potion.effect.leaping": "Распрскувачка напивка за скокање",
  "item.minecraft.splash_potion.effect.levitation": "Распрскувачка напивка за левитација",
  "item.minecraft.splash_potion.effect.luck": "Распрскувачка напивка за среќа",
  "item.minecraft.splash_potion.effect.mundane": "Обична распрскувачка напитва",
  "item.minecraft.splash_potion.effect.night_vision": "Распрскувачка напивка за ноќно гледање",
  "item.minecraft.splash_potion.effect.oozing": "Splash Potion of Oozing",
  "item.minecraft.splash_potion.effect.poison": "Распрскувачка напивка за труење",
  "item.minecraft.splash_potion.effect.regeneration": "Распрскувачка напивка за регенерација",
  "item.minecraft.splash_potion.effect.slow_falling": "Распрскувачка напивка за бавно паѓање",
  "item.minecraft.splash_potion.effect.slowness": "Распрскувачка напивка за бавност",
  "item.minecraft.splash_potion.effect.strength": "Распрскувачка напивка за сила",
  "item.minecraft.splash_potion.effect.swiftness": "Распрскувачка напивка за брзина",
  "item.minecraft.splash_potion.effect.thick": "Густа распрскувачка напивка",
  "item.minecraft.splash_potion.effect.turtle_master": "Распрскувачка напивка на господарот на желките",
  "item.minecraft.splash_potion.effect.water": "Распрскувачко шише со вода",
  "item.minecraft.splash_potion.effect.water_breathing": "Распрскувачка напивка за подводно дишење",
  "item.minecraft.splash_potion.effect.weakness": "Распрскувачка напивка за слабост",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "Чамец од смрека",
  "item.minecraft.spruce_chest_boat": "Чамец од смрека со ковчег",
  "item.minecraft.spyglass": "Шпионско стакло",
  "item.minecraft.squid_spawn_egg": "Јајце за создавање лигња",
  "item.minecraft.stick": "Стап",
  "item.minecraft.stone_axe": "Камена секира",
  "item.minecraft.stone_hoe": "Камена мотика",
  "item.minecraft.stone_pickaxe": "Камен копач",
  "item.minecraft.stone_shovel": "Камена лопата",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "Камен меч",
  "item.minecraft.stray_spawn_egg": "Јајце за создавање скитник",
  "item.minecraft.strider_spawn_egg": "Јајце за Создавање Чекорец",
  "item.minecraft.string": "Конец",
  "item.minecraft.sugar": "Шеќер",
  "item.minecraft.suspicious_stew": "Сомнителна чорба",
  "item.minecraft.sweet_berries": "Слатки бобинки",
  "item.minecraft.tadpole_bucket": "Кофа со полноглавци",
  "item.minecraft.tadpole_spawn_egg": "Јајце за создавање полноглавец",
  "item.minecraft.tide_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armor Trim",
  "item.minecraft.tipped_arrow": "Засилена стрела",
  "item.minecraft.tipped_arrow.effect.awkward": "Засилена стрела",
  "item.minecraft.tipped_arrow.effect.empty": "Несоздавачка засилена стрела",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Стрела на отпорноста на оган",
  "item.minecraft.tipped_arrow.effect.harming": "Стрела на повредувањето",
  "item.minecraft.tipped_arrow.effect.healing": "Стрела на лекувањето",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow of Infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "Стрела на невидливоста",
  "item.minecraft.tipped_arrow.effect.leaping": "Стрела на скокањето",
  "item.minecraft.tipped_arrow.effect.levitation": "Стрела на левитацијата",
  "item.minecraft.tipped_arrow.effect.luck": "Стрела на среќата",
  "item.minecraft.tipped_arrow.effect.mundane": "Засилена стрела",
  "item.minecraft.tipped_arrow.effect.night_vision": "Стрела на ноќното гледање",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "Стрела на отровот",
  "item.minecraft.tipped_arrow.effect.regeneration": "Стрела на регенерацијата",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Стрела на бавното паѓање",
  "item.minecraft.tipped_arrow.effect.slowness": "Стрела на бавноста",
  "item.minecraft.tipped_arrow.effect.strength": "Стрела на силата",
  "item.minecraft.tipped_arrow.effect.swiftness": "Стрела на брзината",
  "item.minecraft.tipped_arrow.effect.thick": "Засилена стрела",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Стрела на господарот на желките",
  "item.minecraft.tipped_arrow.effect.water": "Стрела на распрскувањето",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Стрела на подводното дишење",
  "item.minecraft.tipped_arrow.effect.weakness": "Стрела на слабоста",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Charging",
  "item.minecraft.tnt_minecart": "Рударска количка со ТНТ",
  "item.minecraft.torchflower_seeds": "Torchflower Seeds",
  "item.minecraft.totem_of_undying": "Тотем на бесмртноста",
  "item.minecraft.trader_llama_spawn_egg": "Јајце за создавање лама на трговец",
  "item.minecraft.trial_key": "Trial Key",
  "item.minecraft.trident": "Трозабец",
  "item.minecraft.tropical_fish": "Тропска риба",
  "item.minecraft.tropical_fish_bucket": "Кофа со тропска риба",
  "item.minecraft.tropical_fish_spawn_egg": "Јајце за создавање тропска риба",
  "item.minecraft.turtle_helmet": "Желкина школка",
  "item.minecraft.turtle_scute": "Turtle Scute",
  "item.minecraft.turtle_spawn_egg": "Јајце за создавање желка",
  "item.minecraft.vex_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armor Trim",
  "item.minecraft.vex_spawn_egg": "Јајце за создавање напаст",
  "item.minecraft.villager_spawn_egg": "Јајце за создавање селанец",
  "item.minecraft.vindicator_spawn_egg": "Јајце за создавање бранител",
  "item.minecraft.wandering_trader_spawn_egg": "Јајце за создавање трговец-скитник",
  "item.minecraft.ward_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "Водич за мрестење јајце",
  "item.minecraft.warped_fungus_on_a_stick": "Луда Печурка на Стап",
  "item.minecraft.water_bucket": "Кофа со вода",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "Пченица",
  "item.minecraft.wheat_seeds": "Семе од пченица",
  "item.minecraft.white_bundle": "White Bundle",
  "item.minecraft.white_dye": "Бела фарба",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Wind Charge",
  "item.minecraft.witch_spawn_egg": "Јајце за создавање вештерка",
  "item.minecraft.wither_skeleton_spawn_egg": "Јајце за создавање видер скелет",
  "item.minecraft.wither_spawn_egg": "Wither Spawn Egg",
  "item.minecraft.wolf_armor": "Wolf Armor",
  "item.minecraft.wolf_spawn_egg": "Јајце за создавање волк",
  "item.minecraft.wooden_axe": "Дрвена секира",
  "item.minecraft.wooden_hoe": "Дрвена мотика",
  "item.minecraft.wooden_pickaxe": "Дрвен копач",
  "item.minecraft.wooden_shovel": "Дрвена лопата",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "Дрвен меч",
  "item.minecraft.writable_book": "Книга и перо",
  "item.minecraft.written_book": "Напишана книга",
  "item.minecraft.yellow_bundle": "Yellow Bundle",
  "item.minecraft.yellow_dye": "Жолта фарба",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "Јајце за Создавање Зомби Пеколска Свиња",
  "item.minecraft.zombie_horse_spawn_egg": "Јајце за создавање зомби коњ",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Јајце за создавање зомби",
  "item.minecraft.zombie_villager_spawn_egg": "Јајце за создавање на зомби-селанец",
  "item.minecraft.zombified_piglin_spawn_egg": "Јајце за Создавање Зомбиран Свински Човек"
}
export const mk_mk = items; 
